// import { hooks } from 'botframework-webchat-component';
import React, { useState, useMemo, useEffect, useRef } from 'react';
import submitSendBox from "botframework-webchat-core/lib/actions/submitSendBox";
import setSendBox from "botframework-webchat-core/lib/actions/setSendBox";
import sendPostback from "botframework-webchat-core/lib/actions/sendPostBack";

import ReactDOM from 'react-dom';

/*PARA USAR COGNITIVE SERVICES SDK (createCognitiveServicesSpeechServicesPonyfillFactory)*/
import ReactWebChat, { createDirectLine, createStore, createStyleSet, createCognitiveServicesSpeechServicesPonyfillFactory, createBrowserWebSpeechPonyfillFactory } from 'botframework-webchat';

const $ = window.$; // Import JQuery
const AWS = window.AWS; // Import AWS
/* Synthesizes plain text or SSML into a file of human-like speech. */
var polly = null;
var aContext = null;
var source = null;
var arraySynthesisPhrases = new Array();
var firstInteractionUser = false;
var parametersSent = false;
var saniaSpeak = true;
var tipoVideoAvatarActual = 0;
// EVENTO PARA LANZAR ANURA-BRABU DESDE APP (RUBEN SALUD_CONECTADA)
window.eventBrabu = document.createEvent('Event');
window.eventBrabu.initEvent('anura', true, true);
// EVENTO PRUEBAS PARA INTEGRARNOS CON MI SANITAS (FABIAN)
window.eventMiSanitas = document.createEvent('Event');
window.eventMiSanitas.initEvent('sania', true, true);
// CREDENCIALES SERVICIOS
var sania_credentials = {};
// CREDENCIALES LOCALES
var secret_directline = process.env.REACT_APP_DIRECTLINE_AUTHORIZATION;
var id_sania_webchat = process.env.REACT_APP_ID_SANIA_WEBCHAT;
var endpoint_webapp = process.env.REACT_APP_ENDPOINT_WEB_APP;

//---------------------------------------------------------------------

function getCredentials() {
	return new Promise(async (resolve) => {
		try {
			const requestOptions = {
				method: "GET",
				redirect: "follow",
				timeout: 700
			};
			let url = endpoint_webapp + "tokens";
			const response = await fetch(url, requestOptions);
			if (!response.ok) {
				throw new Error(`Response status: ${response.status}`);
			}
			const json = await response.json();
			resolve(json);
		} catch (error) {
			console.log(error.message);
			resolve(null);
		}
	});
}

async function setCredentials() {
	let data = await getCredentials();
	if (data) {
		sania_credentials.COGNITIVE_SERVICES_SUBSCRIPTION_KEY = data.azure_cognitive_services;
		// sania_credentials.GOOGLE_TTS_KEY = ; // DESACTIVADO
		AWS.config.region = data.aws_services.region;
		AWS.config.accessKeyId = data.aws_services.key;
		AWS.config.secretAccessKey = data.aws_services.secret;
		polly = new AWS.Polly();
	}
} 

//---------------------------------------------------------------------

function generateUniqueId() {
	return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
		return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
	});
}

function scrollToEndCustom() {
	let scrollDiv = $('ul[role="list"]').first().parent();
	if (scrollDiv) scrollDiv.scrollTop(scrollDiv[0].scrollHeight);
}

//---------------------------------------------------------------------

// Get latitude and longitude from client IP
//---------------------------------------------------------------------

async function getLatitudeLongitude(ip, resolve) {

	await fetch('https://ipapi.co/' + ip + '/json', { method: 'GET', timeout: 700 })
		.then((response) => {
			if (!response.ok) throw new Error(response.status);
			else return response.json();
		})
		.then((data) => {
			if (data.hasOwnProperty("latitude")) {
				var miGeoPosition = data.latitude + ", " + data.longitude;
				resolve(miGeoPosition);
			} else {
				resolve(null);
			}
		})
		.catch((error) => {
			console.log("Error: " + JSON.stringify(error));
			resolve(null);
		});
}

async function getGeoPosition() {
	return new Promise(resolve => {
		fetch('https://api.ipify.org/?format=json', { method: 'GET', timeout: 700 })
			.then((response) => {
				if (!response.ok) throw new Error(response.status);
				else return response.json();
			})
			.then((data) => {
				getLatitudeLongitude(data.ip, resolve);
			})
			.catch((error) => {
				console.log("Error: " + JSON.stringify(error));
				resolve(null);
			});
	});
}

//---------------------------------------------------------------------

function get_browser() {
	var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return { name: 'IE', version: (tem[1] || '') };
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR|Edge\/(\d+)/)
		if (tem != null) { return { name: 'Opera', version: tem[1] }; }
	}
	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) != null) { M.splice(1, 1, tem[1]); }
	return {
		name: M[0],
		version: M[1]
	};
}

//---------------------------------------------------------------------

function updateAvailabilitiesFirstButton(){
	// Array con los nombres de los días de la semana en español, inglés y catalán
    let daysOfWeek = [
        "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo",
        "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday",
        "Dilluns", "Dimarts", "Dimecres", "Dijous", "Divendres", "Dissabte", "Diumenge"
    ];
	// Selecciona el primer elemento con la clase 'ac-actionSet'
	var firstActionSet = document.querySelector('.ac-actionSet');
	// Verifica si el elemento existe
	if (firstActionSet) {
		// Comprobamos si el 'aria-label' del botón del 'ac-actionSet' contiene algún día de la semana (para solo hacer click en las cards que sean de seleccion de huecos)
		var firstButton = firstActionSet.querySelector('button');
		if(firstButton && firstButton.classList.contains('expandable') && !firstButton.classList.contains('expanded')){
			var ariaLabel = firstButton.getAttribute('aria-label'); 
			if (ariaLabel && daysOfWeek.some(day => ariaLabel.includes(day)) ) {
				// Lanza el evento de clic en el botón
				firstButton.click();
			}
		}
	}
}

function cleanParameters(){
	// Selecciona todos los elementos <p> con la clase "plain css-161djqc"
	const paragraphs = document.querySelectorAll("p.plain.css-161djqc");

	paragraphs.forEach((paragraph) => {
		// Divide el contenido del texto por "@PARAMETERS@"
		const splitContent = paragraph.textContent.split("@PARAMETERS@");
	
		// Si hay texto antes del "@PARAMETERS@", se lo asigna como nuevo contenido
		if (splitContent.length > 0) {
			paragraph.textContent = splitContent[0];
		}
	});
}

//---------------------------------------------------------------------

function changeVideo(id_siguiente_video = null, op = 0) {
	// Agrupamos los ID de videos por categoria
	let idSourcesIdleSilence = [
		"silence1",
		"silence2",
		"silence3",
		"silence4",
		"silence9"
	];
	let idSourcesIdleSpeak = [
		"speak1",
		"speak2",
		"speak3",
		"speak4"
	];
	let allSourcesIdle = idSourcesIdleSilence.concat(idSourcesIdleSpeak);
	// Obtenemos el idActual
	let id_actual = null;
	for (var i = 0; i < allSourcesIdle.length; i++) {
		let videoAvatar = document.querySelector("#" + allSourcesIdle[i]);
		if (videoAvatar && videoAvatar.style.display == "block") {
			id_actual = allSourcesIdle[i];
			break;
		}
	}
	// Cambiamos el video al siguiente video ID
	if (op !== tipoVideoAvatarActual) { tipoVideoAvatarActual = op }
	document.querySelector("#" + id_actual).style.display = "none";
	if (id_siguiente_video) {
		id_actual = id_siguiente_video;
	} else {
		if (tipoVideoAvatarActual == 0) { // silence
			id_actual = idSourcesIdleSilence[Math.floor(Math.random() * idSourcesIdleSilence.length)];
			let animacionSpeakAvatar = document.getElementsByClassName("voiceChat-animacionAnimationContainer");
			animacionSpeakAvatar[0].className = "voiceChat-animacionAnimationContainer";
			//voiceChat-animacionExtra
		} else { // speak
			id_actual = idSourcesIdleSpeak[Math.floor(Math.random() * idSourcesIdleSpeak.length)];
			let animacionSpeakAvatar = document.getElementsByClassName("voiceChat-animacionAnimationContainer");
			animacionSpeakAvatar[0].className += " voiceChat-animacionAvatarSpeaking";
		}
	}
	document.querySelector("#" + id_actual).style.display = "block";
	document.querySelector("#" + id_actual).play();
	// Definimos el evento
	document.querySelector("#" + id_actual).addEventListener('ended', function _func() {
		document.querySelector("#" + id_actual).removeEventListener('ended', _func);
		changeVideo(null, tipoVideoAvatarActual);
	});
}

//---------------------------------------------------------------------

async function saniaSpeech(text = null, pavatar, language, ptts) {

	if (source) try { source.stop(); } catch (error) { }

	if (!text && arraySynthesisPhrases.length > 0) {
		text = arraySynthesisPhrases[0];
	}
	if (text && text.length > 0) {

		let audioBuffer = null;
		// if (ptts.trim().toLocaleLowerCase() == "google") {

		// 	let address = "https://texttospeech.googleapis.com/v1/text:synthesize?key=" + sania_credentials.GOOGLE_TTS_KEY;
		// 	let payload = {
		// 		headers: {
		// 			'Content-Type': 'application/json'
		// 		},
		// 		body: JSON.stringify({
		// 			"input": {
		// 				"text": text
		// 			},
		// 			"voice": {
		// 				"languageCode": "es-ES",
		// 				"name": "es-ES-Wavenet-C",
		// 				"ssmlGender": "FEMALE"
		// 			},
		// 			"audioConfig": {
		// 				"audioEncoding": "MP3"
		// 			}
		// 		}),
		// 		method: 'POST'
		// 	};
		// 	try {
		// 		let response = await fetch(address, payload)
		// 		let result = await response.json();
		// 		let audioBase64 = result.audioContent;

		// 		let binary_string = window.atob(audioBase64);
		// 		let len = binary_string.length;
		// 		let bytes = new Uint8Array(len);
		// 		for (let i = 0; i < len; i++) {
		// 			bytes[i] = binary_string.charCodeAt(i);
		// 		}
		// 		audioBuffer = bytes.buffer;
		// 	} catch (err) {
		// 		console.warn(err)
		// 	}

		// } else {
			// Parametros amazon polly
			let voiceBot = "Lucia"; // Español default
			if (language === "en") voiceBot = "Salli"; // Ingles default
			else if (language === "ca") voiceBot = "Arlet"; // Catalan
			if (pavatar === "2") { voiceBot = "Conchita"; } // es-ES
			else if (pavatar === "4") { voiceBot = "Mia"; } // es-MX
			else if (pavatar === "5") { voiceBot = "Lupe"; } // es-US Neural
			else if (pavatar === "6") { voiceBot = "Amy"; } // en-GB Neural
			else if (pavatar === "7") { voiceBot = "Joanna"; } // en-US Neural
			var params = {
				Engine: "standard",
				OutputFormat: "mp3",
				SampleRate: "8000",
				Text: text,
				TextType: "text",
				VoiceId: voiceBot
			};
			if (voiceBot === "Arlet") { params["Engine"] = "neural"; }
			// Sintesis
			const result = await polly.synthesizeSpeech(params).promise();
			audioBuffer = result.AudioStream.buffer;
		// }
		source = aContext.createBufferSource();
		source.onended = function () {
			arraySynthesisPhrases.shift();
			if (pavatar !== "" && pavatar !== null && pavatar !== undefined) {
				if (arraySynthesisPhrases.length == 0) { changeVideo(null, 0); } // Silence
			}
			saniaSpeech(null, pavatar, language, ptts);
		}
		await aContext.decodeAudioData(audioBuffer, (buffer) => {
			if (pavatar !== "" && pavatar !== null && pavatar !== undefined) { changeVideo(null, 1); } // Speak
			source.buffer = buffer;
			source.connect(aContext.destination);
			source.start();
		}, (e) => { window.reject(e); });

	}
}

//---------------------------------------------------------------------

function stopSaniaSpeech() {
	arraySynthesisPhrases = new Array();
	if (firstInteractionUser && saniaSpeak && source) {
		try { source.stop(); } catch (error) { }
	}
}

//---------------------------------------------------------------------

function isEven(value) { if (value % 2 == 0) { return true; } else { return false; } }

//---------------------------------------------------------------------

function initAudioContext() { if (!aContext) { aContext = new (window.AudioContext || window.webkitAudioContext)(); aContext.resume(); } }

//---------------------------------------------------------------------

function removeEmojis(string) { var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|[\ud83c[\ude50\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g; return string.replace(regex, '').trim(); }

function removeStrangeCharacters(string) { return string.replace(/[^a-zA-z0-9ñÑáéíóúÁÉÍÓÚ\s!¿?,.@\/-]+/g, "").replace(/\s+/g, " ") }

function applyXssProtection(string) { return string.replace(/</g, "&lt;").replace(/>/g, "&gt;"); };

//---------------------------------------------------------------------

function hiddenButtonAfterUserInput() {

	// -------------------------------------------------------------------------------------------------------------
	// IMBACK --> OCULTAR ADAPTIVE CARDS CUANDO EL USUARIO HA ESCRITO Y ENVIADO ALGUN MENSAJE
	// -------------------------------------------------------------------------------------------------------------
	var rowOcultar01 = Array.from(document.querySelectorAll('li[role="listitem"]'));
	//alert("DESPUES DE ROWOCULTAR 01:" + rowOcultar01.length);
	for (var a = 0; a < rowOcultar01.length; a++) {
		//Simular :scope para que funcione en Edge
		const UUID = Date.now() + '';
		rowOcultar01[a].setAttribute('data-scope-uuid', UUID);

		var botones01 = Array.from(rowOcultar01[a].querySelectorAll('[data-scope-uuid="' + UUID + '"] .ac-pushButton'));

		rowOcultar01[a].removeAttribute('data-scope-UUID');

		//alert("DESPUES DE BOTONES 01:" + botones01.length);
		if (botones01.length > 0) {
			for (var b = 0; b < botones01.length; b++) {
				var boton01 = botones01[b];
				if ((boton01.innerText.toUpperCase() === "SOLICITAR") || (boton01.getAttribute("aria-label").toUpperCase() === "ACTUALIZAR PRECIO")) {
					rowOcultar01[a].parentNode.removeChild(rowOcultar01[a]);
				}
			}
		}
	}

	// -------------------------------------------------------------------------------------------------------------
	// POSTBACK --> PARA ADAPTIVE CARDS CON BOTONES DE SELECCION 
	// -------------------------------------------------------------------------------------------------------------
	var rowOcultar = Array.from(document.querySelectorAll('li[role="listitem"]'));
	for (var i = 0; i < rowOcultar.length; i++) {

		//Simular :scope para que funcione en Edge
		const UUID = Date.now() + '';
		rowOcultar[i].setAttribute('data-scope-uuid', UUID);

		var botones = Array.from(rowOcultar[i].querySelectorAll('[data-scope-uuid="' + UUID + '"] .ac-pushButton'));
		var botonesList = Array.from(rowOcultar[i].querySelectorAll('[data-scope-uuid="' + UUID + '"] .ac-selectable'));

		// Botones que no ocultan la card al pulsarlos...
		if (botones.length > 0 || botonesList.length > 0) {
			var saltar = false;

			if (botones.length > 0) {
				for (var m = 0; m < botones.length; m++) {
					var boton = botones[m];
					if ((boton.innerText.toUpperCase() === "ACCEDER") || (boton.innerText.toUpperCase() === "PAGO ONLINE")) {
						saltar = true;
					}
				}
			}

			if (!saltar) {
				var rowMessage = Array.from(rowOcultar[i].querySelectorAll('[data-scope-uuid="' + UUID + '"] .webchat__row.message'));
				var rowAttachment = Array.from(rowOcultar[i].querySelectorAll('[data-scope-uuid="' + UUID + '"] .webchat__row.attachment'));

				if (rowMessage.length === 0 && rowAttachment.length === 0) {
					rowOcultar[i].parentNode.removeChild(rowOcultar[i]);
				} else {
					if (rowMessage.length > 0) {
						rowMessage[0].setAttribute('data-scope-p', 'vacio');
						rowMessage[0].removeAttribute('data-scope-p');
					}

					if (rowAttachment.length > 0) {
						rowAttachment.forEach(element => {
							element.parentNode.removeChild(element);
						});
					}
				}
			}
		}
		rowOcultar[i].removeAttribute('data-scope-UUID');

	}

	// FIN OCULTAR ADAPTIVE CARDS CUANDO EL USUARIO HA ESCRITO Y ENVIADO ALG�N MENSAJE ..................................................
}

//---------------------------------------------------------------------

function hiddenButtonAfterUserInputVoiceUI() {
	// Se ocultan todos los row-buttons en voice UI cada vez que se hace click en una opción
	let deleteRows = document.getElementsByClassName("row-Buttons");
	while (deleteRows.length > 0) {
		deleteRows[0].style.display = "none";
		deleteRows[0].className = " ";
	}
}

//---------------------------------------------------------------------

function writeMessageVoiceUI(user, action, store) {
	//Funcion de pintar mensajes
	if ((action.payload && action.payload.text && action.payload.text.trim().length > 0) || (action.payload && action.payload.activity && action.payload.activity.text && action.payload.activity.text.trim().length > 0) || (action.payload && action.payload.channelData && action.payload.channelData.speech && action.payload.channelData.speech.alternatives && (action.payload.channelData.speech.alternatives.length > 0) && action.payload.channelData.speech.alternatives[0].transcript)) {

		let inputText = null;

		if (action.payload.activity) {
			inputText = action.payload.activity.text;
		} else if (action.payload.text) {
			inputText = action.payload.text;
		} else {
			inputText = action.payload.channelData.speech.alternatives[0].transcript;
		}

		if (inputText) {
			let div1 = document.createElement('div');
			if (user === "bot") {
				div1.className = "voiceChat-mensajeRow";
			} else {
				div1.className = "voiceChat-mensajeRow user";
			}
			let div2 = document.createElement('div');
			div2.className = "bubbleVoiceChat";
			div2.innerHTML += inputText;

			// Cambiar los ** por el <strong></strong>
			let splitMessage = div2.innerHTML.split("**");
			let auxMessage = "";
			splitMessage.forEach(function (element, index) {
				auxMessage += element;
				if (index < splitMessage.length - 1) {
					if (isEven(index)) auxMessage += "<strong>";
					else auxMessage += "</strong>";
				}
			});
			div2.innerHTML = auxMessage;

			//Cambiar los \n\n por </br>
			let splitMessage2 = div2.innerHTML.split("\n");
			let auxMessage2 = "";
			splitMessage2.forEach(function (element) {
				auxMessage2 += element;
				auxMessage2 += "<br>";
			});
			div2.innerHTML = auxMessage2;

			// Cambiar los [] por el <a></a>
			if (div2.innerHTML.indexOf("](") !== -1) {
				let auxSplit = div2.innerHTML.split("](");
				let name_link = auxSplit[0].split("[")[auxSplit[0].split("[").length - 1];
				let url_link = auxSplit[1].split(")")[0];
				div2.innerHTML = auxSplit[0].split("[").splice(0, auxSplit[0].split("[").length - 1).join("[") + '<a href="' + url_link + '" target="_blank">' + name_link + '</a>';
			}

			div1.appendChild(div2);
			//div1.appendChild(carouselRow);
			let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
			chatVoiceUI[0].appendChild(div1);
		}

		//Funcion de pintar Suggested Actions
	} else if (action.payload && action.payload.activity && action.payload.activity.suggestedActions && action.payload.activity.suggestedActions.actions && action.payload.activity.suggestedActions.actions.length > 0) {

		//Si hay mas de un botón les pone las clases para que se pongan en linea por pares
		if (action.payload.activity.suggestedActions.actions.length > 1) {
			let suggestedActions = action.payload.activity.suggestedActions;
			let div1 = document.createElement('div');
			div1.className = "voiceChat-mensajeRow row-Buttons";
			let div2 = document.createElement('div');
			div2.className = "voiceChat-ButtonContainer";
			div1.appendChild(div2);

			for (var j = 0; j < suggestedActions.actions.length; j++) {
				let but1 = document.createElement('button');
				let title = suggestedActions.actions[j].title.trim();
				let value = suggestedActions.actions[j].value.trim();
				but1.value = value;
				but1.className = "voiceChat-Button";
				but1.innerHTML += title;
				but1.onclick = function () {
					store.dispatch(setSendBox(value));
					store.dispatch(submitSendBox());
				}
				div2.appendChild(but1);
			}

			let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
			chatVoiceUI[0].appendChild(div1);

			//Si solo hay un boton le pone la clase Full que le da el ancho total
		} else if (action.payload.activity.suggestedActions.actions.length == 1) {

			let suggestedActions = action.payload.activity.suggestedActions;
			let div1 = document.createElement('div');
			div1.className = "voiceChat-mensajeRow row-Buttons";
			let div2 = document.createElement('div');
			div2.className = "voiceChat-ButtonContainer";
			div1.appendChild(div2);

			for (var j = 0; j < suggestedActions.actions.length; j++) {
				let but1 = document.createElement('button');
				let title = suggestedActions.actions[j].title.trim();
				let value = suggestedActions.actions[j].value.trim();
				but1.value = value;
				but1.className = "voiceChat-Button";
				but1.className += " voiceChat-ButtonFull";
				but1.innerHTML += title;
				but1.onclick = function () {
					store.dispatch(setSendBox(value));
					store.dispatch(submitSendBox());
				}
				div2.appendChild(but1);
			}

			let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
			chatVoiceUI[0].appendChild(div1);

		}

		// Funcion de pintar Suggested Actions y Especialidades
	} else if (action.payload && action.payload.activity && action.payload.activity.attachments && action.payload.activity.attachments.length > 0) {

		//Funcion de pintar de Suggested Actions ampliado, Especialidades y Card de Chequeos
		if (action.payload.activity.attachments[0].contentType == "application/vnd.microsoft.card.adaptive") {

			//Comprueba si tienes selectActions y pinta las Suggested Actions
			if (action.payload.activity.attachments[0].content.selectAction) {

				if (action.payload.activity.attachments[0].content.selectAction.data) {

					let SuggestedActionsAttachment = action.payload.activity.attachments;
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow row-Buttons";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-actionsContainer";
					div1.appendChild(div2);

					SuggestedActionsAttachment.forEach(element => {
						let div3 = document.createElement('div');
						let but1 = document.createElement('button');
						let p1 = document.createElement('p');
						let img1 = document.createElement('img');
						let title = element.content.selectAction.data.trim();
						let value = element.content.selectAction.data.trim();
						let url = element.content.body[0].columns[0].items[0].url.trim();
						div3.className = "voiceChat-actionsButtonContainer";
						but1.value = value;
						but1.className = "voiceChat-actionsButton";
						but1.onclick = function () {
							store.dispatch(setSendBox(value));
							store.dispatch(submitSendBox());
						}
						p1.innerHTML += title;
						img1.src = url;
						but1.appendChild(img1);
						but1.appendChild(p1);
						div3.appendChild(but1);
						div2.appendChild(div3);
					});

					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);

					//Pinta el JSON de las pruebas covid
				} else {

					let SuggestedActionsAttachment = action.payload.activity.attachments;
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow row-Buttons";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-actionsContainer";
					div1.appendChild(div2);

					SuggestedActionsAttachment.forEach(element => {
						let div3 = document.createElement('div');
						let but1 = document.createElement('button');
						let p1 = document.createElement('p');
						let img1 = document.createElement('img');

						//Aquí empieza a cambiar, comprobar si el contenido del bucle tiene url o es solo la card
						if (element.content.selectAction.data) {

							let title = element.content.selectAction.data.trim();
							let value = element.content.selectAction.data.trim();
							let url = element.content.body[0].columns[0].items[0].url.trim();
							div3.className = "voiceChat-actionsButtonContainer";
							but1.value = value;
							but1.className = "voiceChat-actionsButton";
							but1.onclick = function () {
								store.dispatch(setSendBox(value));
								store.dispatch(submitSendBox());

								//Aquí poner funcion de abrir nueva tab con la url
							}
							p1.innerHTML += title;
							img1.src = url;
							but1.appendChild(img1);
							but1.appendChild(p1);
							div3.appendChild(but1);
							div2.appendChild(div3);

						} else if (element.content.selectAction.url) {

							let title = element.content.body[0].columns[1].items[0].text.trim();
							//let value = element.content.selectAction.data.trim();
							let imgurl = element.content.body[0].columns[0].items[0].url.trim();
							let url = element.content.selectAction.url.trim();
							div3.className = "voiceChat-actionsButtonContainer";
							//but1.value = value;
							but1.className = "voiceChat-actionsButton";
							but1.onclick = function () {
								window.open(url, '_blank');

								//Aquí poner funcion de abrir nueva tab con la url
							}
							p1.innerHTML += title;
							img1.src = imgurl;
							but1.appendChild(img1);
							but1.appendChild(p1);
							div3.appendChild(but1);
							div2.appendChild(div3);
						}
					});

					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);
				}

				// Comprueba si tienes Actions y pinta las especialidades, médicos o login
			} else if (action.payload.activity.attachments[0].content.actions) {

				// Calendario Peticion Cita
				if (action.payload.activity.attachments[0].content.body && action.payload.activity.attachments[0].content.body.length == 1 && JSON.stringify(action.payload.activity.attachments[0].content.body).includes("Input.Date")) {
					let calendarBody = action.payload.activity.attachments[0].content.body[0];
					let calendarAction = action.payload.activity.attachments[0].content.actions[0];
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow row-Buttons";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-calendar";
					div1.appendChild(div2);
					let calendarTitle = document.createElement('p');
					calendarTitle.className = "voiceChat-calendarTitle";
					calendarTitle.innerHTML = calendarBody.columns[0].items[0].text;
					let calendarInput = document.createElement('input');
					calendarInput.className = "voiceChat-calendarInput";
					calendarInput.type = "date";
					calendarInput.min = "undefined";
					calendarInput.max = "undefined";
					let dateNow = new Date();
					calendarInput.value = dateNow.getFullYear() + "-" + (dateNow.getMonth() + 1).toString().padStart(2, 0) + "-" + dateNow.getDate().toString().padStart(2, 0);
					let calendarSubmit = document.createElement('input');
					calendarSubmit.className = "voiceChat-actionsCalendarSubmit";
					calendarSubmit.type = "submit";
					calendarSubmit.innerHTML = calendarAction.title;
					calendarSubmit.onclick = function () {
						let value = JSON.parse(('{"fecha": "' + calendarInput.value + '"}'));
						store.dispatch(sendPostback(value));
						hiddenButtonAfterUserInputVoiceUI();
					}
					div2.appendChild(calendarTitle);
					div2.appendChild(calendarInput);
					div2.appendChild(calendarSubmit);
					div1.appendChild(div2);
					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);

					// Mira si es el login y lo pinta
				} else if (action.payload.activity.attachments[0].content.body && action.payload.activity.attachments[0].content.body.length > 1 && action.payload.activity.attachments[0].content.body[1].id && action.payload.activity.attachments[0].content.body[1].id == "user") {

					let loginBody = action.payload.activity.attachments[0].content.body;
					let loginAction = action.payload.activity.attachments[0].content.actions;
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-login";
					div1.appendChild(div2);
					let input1 = document.createElement("input");
					let input2 = document.createElement("input");
					let texto1 = document.createElement("p");
					let texto2 = document.createElement("p");
					let submit = document.createElement("input");
					input1.type = "text";
					input2.type = "password";
					input1.id = loginBody[1].id;
					input2.id = loginBody[3].id;
					input1.className = "voiceChat-userInput";
					input2.className = "voiceChat-userInput";
					texto1.innerHTML = loginBody[0].text;
					texto2.innerHTML = loginBody[2].text;
					texto1.className = "voiceChat-userTexto";
					texto2.className = "voiceChat-userTexto";
					submit.type = "submit";
					submit.value = loginAction[0].title;
					submit.onclick = function () {
						let value = JSON.parse(('{"' + input1.id + '": "' + input1.value + '", "' + input2.id + '": "' + input2.value + '"}'));
						store.dispatch(sendPostback(value));
					}
					submit.className = "voiceChat-userSubmit";
					div2.appendChild(texto1);
					div2.appendChild(input1);
					div2.appendChild(texto2);
					div2.appendChild(input2);
					div2.appendChild(submit);
					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);

					//Combrueba si es el pack de botones para cambiar chequeos y lo pinta
				} else if (action.payload.activity.attachments[0].content.body) {
					// console.log(JSON.stringify(action.payload.activity));

					// Checkbox
					if (action.payload.activity.attachments[0].content.body.length > 1 && action.payload.activity.attachments[0].content.body[1].type == "Input.ChoiceSet") {
						// Pack de botones para cambiar chequeos
						let cambiosBody = action.payload.activity.attachments[0].content.body;
						let cambiosAction = action.payload.activity.attachments[0].content.actions;
						let div1 = document.createElement('div');
						div1.className = "voiceChat-mensajeRow";
						let div2 = document.createElement('div');
						div2.className = "voiceChat-chequeoCambios";
						div1.appendChild(div2);

						let cambiosTitulo = document.createElement("p");
						cambiosTitulo.className = "voiceChat-chequeoCambiosTitulo";
						cambiosTitulo.innerHTML = cambiosBody[0].text;
						div2.appendChild(cambiosTitulo);

						let elementsChecked = cambiosBody[1].value.split(",");
						for (var j = 0; j < cambiosBody[1].choices.length; j++) {
							let inputContainer = document.createElement("div");
							inputContainer.className = "voiceChat-chequeoCambiosRow";
							let inputCheckbox = document.createElement("input");
							let inputLabel = document.createElement("label");

							inputCheckbox.type = "checkbox";
							inputCheckbox.value = cambiosBody[1].choices[j].value;
							inputCheckbox.className = "voiceChat-chequeoCambiosCheckbox";
							if (elementsChecked.includes(cambiosBody[1].choices[j].value.trim())) {
								inputCheckbox.checked = true;
							} else {
								inputCheckbox.checked = false;
							}
							inputContainer.appendChild(inputCheckbox);

							inputLabel.innerHTML = cambiosBody[1].choices[j].title;
							inputLabel.className = "voiceChat-chequeoCambiosLabel";
							inputContainer.appendChild(inputLabel);

							div2.appendChild(inputContainer);
						}

						let submit = document.createElement("input");
						submit.type = "submit";
						submit.value = cambiosAction[0].title;
						submit.className = "voiceChat-chequeoCambiosSubmit";
						submit.onclick = function () {
							let checkboxElements = document.getElementsByClassName("voiceChat-chequeoCambiosCheckbox");
							let valuesChecked = "";
							for (let i = 0; i < checkboxElements.length; i++) {
								if (checkboxElements[i].checked) valuesChecked += checkboxElements[i].defaultValue + ",";
							}
							valuesChecked = valuesChecked.slice(0, -1);
							let value = JSON.parse(('{"select_checkbox": "' + valuesChecked + '"}'));
							store.dispatch(sendPostback(value));
							hiddenButtonAfterUserInputVoiceUI();
						}
						div2.appendChild(submit);

						let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
						chatVoiceUI[0].appendChild(div1);

						// CARD ACCESO SERVICIOS SANITAS A TRAVES DE URL
					} else {

						// CARD IMAGEN + TEXTO
						if (action.payload.activity.attachments[0].content.body.length > 1 && action.payload.activity.attachments[0].content.body[0].type == "Image" && action.payload.activity.attachments[0].content.body[1].type == "TextBlock") {
							// // EJEMPLO
							// {
							// 	"type": "message",
							// 	"id": "EGKd7CmULcQJGGOlisGONM-a|0000029",
							// 	"timestamp": "2021-05-04T13:47:45.8668549Z",
							// 	"channelId": "webchat",
							// 	"from": {
							// 		"id": "Eliza-bot-dev",
							// 		"name": "Asistente virtual",
							// 		"role": "bot"
							// 	},
							// 	"conversation": {
							// 		"id": "EGKd7CmULcQJGGOlisGONM-a"
							// 	},
							// 	"locale": "es-ES",
							// 	"attachments": [
							// 		{
							// 			"contentType": "application/vnd.microsoft.card.adaptive",
							// 			"content": {
							// 				"type": "AdaptiveCard",
							// 				"version": "1.0",
							// 				"body": [
							// 					{
							// 						"type": "Image",
							// 						"size": "medium",
							// 						"url": "https://cdn.techterms.com/img/lg/pdf_109.png",
							// 						"horizontalAlignment": "center"
							// 					},
							// 					{
							// 						"type": "TextBlock",
							// 						"size": "medium",
							// 						"text": "Preparacion cita.pdf"
							// 					}
							// 				],
							// 				"actions": [
							// 					{
							// 						"type": "Action.OpenUrl",
							// 						"url": "https://sandbox.carpetadesalud.sanihub.com/eliza/documentos/preparaciones//2021-05-04T13:47:42.431013.pdf",
							// 						"title": "Abrir"
							// 					}
							// 				]
							// 			}
							// 		}
							// 	],
							// 	"replyToId": "EGKd7CmULcQJGGOlisGONM-a|0000023"
							// }
						}
					}

				} else {

					//Comprueba si viene más de un pack de 4 botones y los activa el carousel
					if (action.payload.activity.attachments.length > 1) {

						let carouselRow = document.createElement('div');
						carouselRow.className = "voiceChat-mensajeRow row-Buttons owl-carousel owl-theme";

						for (var l = 0; l < action.payload.activity.attachments.length; l++) {

							let attachment = action.payload.activity.attachments[l].content;

							let specialitiesContainer = document.createElement('div');
							specialitiesContainer.className = "voiceChat-ButtonContainer";
							let specialitiesWrapper = document.createElement('div');
							specialitiesWrapper.className = "voiceChat-ButtonCarouselWrapper";

							for (var n = 0; n < attachment.actions.length; n++) {

								let title = attachment.actions[n].data;
								let value = attachment.actions[n].data;
								let butEspecialidad = document.createElement('button');
								butEspecialidad.innerHTML = title;
								butEspecialidad.value = value;
								butEspecialidad.className = "voiceChat-Button";
								specialitiesContainer.appendChild(butEspecialidad);
								butEspecialidad.onclick = function () {
									store.dispatch(setSendBox(value));
									store.dispatch(submitSendBox());
								}
							}
							specialitiesWrapper.appendChild(specialitiesContainer);
							carouselRow.appendChild(specialitiesWrapper);
						}

						let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
						chatVoiceUI[0].appendChild(carouselRow);

						$('.owl-carousel').owlCarousel({
							items: 1,
							loop: false,
							nav: true,
							margin: 10,
						});

						//Si solo viene un pack de 4 botones, los pinta sin carousel
					} else if (action.payload.activity.attachments.length == 1) {
						let doctores = action.payload.activity.attachments[0];
						let div1 = document.createElement('div');
						div1.className = "voiceChat-mensajeRow row-Buttons";
						let div2 = document.createElement('div');
						div2.className = "voiceChat-ButtonContainer";
						div1.appendChild(div2);

						for (var j = 0; j < doctores.content.actions.length; j++) {
							let but1 = document.createElement('button');
							let title = doctores.content.actions[j].title.trim();
							let value = doctores.content.actions[j].data.trim();
							but1.value = value;
							but1.className = "voiceChat-Button";
							but1.innerHTML += title;
							but1.onclick = function () {
								store.dispatch(setSendBox(value));
								store.dispatch(submitSendBox());
							}
							div2.appendChild(but1);
						}

						let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
						chatVoiceUI[0].appendChild(div1);
					}
				}
				//Comprueba si es la card de chequeos
			} else if (action.payload.activity.attachments[0].content.body[0].url) {

				let chequeo = action.payload.activity.attachments[0].content.body;
				let div1 = document.createElement('div');
				div1.className = "voiceChat-mensajeRow";
				let div2 = document.createElement('div');
				div2.className = "voiceChat-chequeoContainer";

				let imgUrl = chequeo[0].url;
				let imgDiv = document.createElement("div");
				let img = document.createElement("img");
				img.src = imgUrl;
				imgDiv.className = "voiceChat-chequeoImgDiv";
				img.className = "voiceChat-chequeoImg";
				imgDiv.appendChild(img);
				div2.appendChild(imgDiv);

				for (j = 1; j < chequeo.length; j++) {
					if (chequeo[j].text != " " || chequeo[j].columns) {
						let chequeoRow = document.createElement("div");
						chequeoRow.className = "voiceChat-chequeoRow";
						if (chequeo[j].weight == "bolder") {
							let chequeoTitulo = document.createElement("p");
							chequeoTitulo.className = "voiceChat-chequeoTitulo";
							chequeoTitulo.innerHTML = chequeo[j].text;
							chequeoRow.appendChild(chequeoTitulo);
						} else if (chequeo[j].columns[0].items) {
							for (n = 0; n < chequeo[j].columns[0].items.length; n++) {
								let chequeoPrueba = document.createElement("p");
								chequeoPrueba.className = "voiceChat-chequeoPrueba";
								chequeoPrueba.innerHTML = chequeo[j].columns[0].items[n].text;
								chequeoRow.appendChild(chequeoPrueba);
							}
						}
						div2.appendChild(chequeoRow);
					}
				}

				div1.appendChild(div2);
				let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
				chatVoiceUI[0].appendChild(div1);
			}

			//Funcion de pintar Botones de respuestas sencillas a flujos y Carousel de centros
		} else if (action.payload.activity.attachments[0].contentType == "application/vnd.microsoft.card.hero") {

			//Mira si son botones sencillos y pinta los botones normal
			if (action.payload.activity.attachments[0].content.images == null) {

				//Si vienen 1 o 3 opciones, hace que ocupen todo el ancho
				if (action.payload.activity.attachments[0].content.buttons.length == 3 || action.payload.activity.attachments[0].content.buttons.length == 1) {

					let buttonActions = action.payload.activity.attachments[0].content.buttons;
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow row-Buttons";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-ButtonContainer";
					div1.appendChild(div2);

					for (var j = 0; j < buttonActions.length; j++) {
						let but1 = document.createElement('button');
						let title = buttonActions[j].title.trim();
						let value = buttonActions[j].value.trim();
						but1.value = value;
						but1.className = "voiceChat-ButtonFull";
						but1.innerHTML += title;
						but1.onclick = function () {
							store.dispatch(setSendBox(value));
							store.dispatch(submitSendBox());
						}
						div2.appendChild(but1);
					}
					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);

					//Si vienen 2 o 4 opciones, pone los botones a pares
				} else {

					let buttonActions = action.payload.activity.attachments[0].content.buttons;
					let div1 = document.createElement('div');
					div1.className = "voiceChat-mensajeRow row-Buttons";
					let div2 = document.createElement('div');
					div2.className = "voiceChat-ButtonContainer";
					div1.appendChild(div2);

					for (var j = 0; j < buttonActions.length; j++) {
						let but1 = document.createElement('button');
						let title = buttonActions[j].title.trim();
						let value = buttonActions[j].value.trim();
						but1.value = value;
						but1.className = "voiceChat-Button";
						but1.innerHTML += title;
						but1.onclick = function () {
							store.dispatch(setSendBox(value));
							store.dispatch(submitSendBox());
						}
						div2.appendChild(but1);
					}
					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(div1);
				}

				//Mira si es el carousel de centros y lo pinta como cards de Slick, o mira si es otro tipo de card-hero con imagen
			} else if (action.payload.activity.attachments[0].content.images) {

				//Mira si tiene titulo y pinta el carrousel de centros
				if (action.payload.activity.attachments[0].content.title) {

					let carouselRow = document.createElement('div');
					carouselRow.className = "voiceChat-mensajeRow row-Buttons owl-carousel owl-theme";

					for (var l = 0; l < action.payload.activity.attachments.length; l++) {

						let attachment = action.payload.activity.attachments[l].content;

						let specialitiesContainer = document.createElement('div');
						specialitiesContainer.className = "voiceChat-ButtonContainer";
						let specialitiesWrapper = document.createElement('div');
						specialitiesWrapper.className = "voiceChat-ButtonCarouselWrapper";

						let title = attachment.title;
						let value = attachment.title;
						let imgSRC = attachment.images[0].url;
						let street = attachment.text;
						let imgCentros = document.createElement('img');
						let tituloCentros = document.createElement('p');
						let calleCentros = document.createElement('p');
						let butCentros = document.createElement('button');

						imgCentros.src = imgSRC;
						imgCentros.className = "voiceChat-CentersImg";
						specialitiesContainer.appendChild(imgCentros);

						tituloCentros.innerHTML = title;
						tituloCentros.className = "voiceChat-CentersTitle";
						specialitiesContainer.appendChild(tituloCentros);

						calleCentros.innerHTML = street;
						calleCentros.className = "voiceChat-CentersStreet";
						specialitiesContainer.appendChild(calleCentros);

						butCentros.innerHTML = "Seleccionar";
						butCentros.value = value;
						butCentros.className = "voiceChat-ButtonFull";
						specialitiesContainer.appendChild(butCentros);

						butCentros.onclick = function () {
							store.dispatch(setSendBox(value));
							store.dispatch(submitSendBox());
						}

						specialitiesWrapper.appendChild(specialitiesContainer);
						carouselRow.appendChild(specialitiesWrapper);
					}

					let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
					chatVoiceUI[0].appendChild(carouselRow);

					$('.owl-carousel').owlCarousel({
						items: 1,
						loop: false,
						margin: 10,
						responsive: {
							600: {
								items: 2,
								nav: true
							}
						}
					});

					//Si no tiene titulo pinta las hero card normales
				} else {
					// console.log("Hola Iñaki, aqui va el JSON no interpretado en UI escrita");
				}

			}

			//Funcion para pintar mensajes con video
		} else if (action.payload.activity.attachments[0].contentType == "application/vnd.microsoft.card.video") {

			//Miramos cual es la URL del video y lo cambiamos por el embebible
			if (action.payload.activity.attachments[0].content.media[0].url == "https://www.youtube.com/watch?v=Gq7jTUYtOz4") {
				let videoContent = action.payload.activity.attachments[0].content;
				let div1 = document.createElement('div');
				div1.className = "voiceChat-mensajeRow";
				let div2 = document.createElement('div');
				div2.className = "voiceChat-videoContainer";
				div1.appendChild(div2);
				let videoTitle = videoContent.title;
				let videoSubtitle = videoContent.subtitle;
				let iframe = document.createElement("iframe");
				let title = document.createElement("p");
				let subtitle = document.createElement("p");
				iframe.className = "videoIframe";
				iframe.setAttribute('allowFullScreen', '');
				title.className = "videoTitle";
				subtitle.className = "videoSubtitle";
				iframe.src = "https://www.youtube.com/embed/Gq7jTUYtOz4";
				iframe.width = "100%";
				iframe.allow = "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
				title.innerHTML += videoTitle;
				subtitle.innerHTML += videoSubtitle;
				div2.appendChild(iframe);
				div2.appendChild(title);
				div2.appendChild(subtitle);
				let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
				chatVoiceUI[0].appendChild(div1);
			}

			//Funcion para pintar mensajes con audio	
		} else if (action.payload.activity.attachments[0].contentType == "application/vnd.microsoft.card.audio") {

			let audioContent = action.payload.activity.attachments[0].content;
			let div1 = document.createElement('div');
			div1.className = "voiceChat-mensajeRow";
			let div2 = document.createElement('div');
			div2.className = "voiceChat-audioContainer";
			div1.appendChild(div2);
			let audioUrl = audioContent.media[0].url;
			let audioTitle = audioContent.title;
			let audioSubtitle = audioContent.subtitle;
			let audio = document.createElement("audio");
			let source = document.createElement("source");
			audio.appendChild(source);
			audio.setAttribute('controls', '');
			source.src = audioUrl;
			source.type = "audio/ogg";
			audio.className = "voiceChat-audioBar"
			let title = document.createElement("p");
			let subtitle = document.createElement("p");
			title.className = "audioTitle";
			subtitle.className = "audioSubtitle";
			title.innerHTML += audioTitle;
			subtitle.innerHTML += audioSubtitle;
			div2.appendChild(audio);
			div2.appendChild(title);
			div2.appendChild(subtitle);
			let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
			chatVoiceUI[0].appendChild(div1);

			//Funcion para pintar el mensaje de cita confirmada
		} else if (action.payload.activity.attachments[0].contentType == "application/vnd.microsoft.card.thumbnail") {

			let confirmacionContent = action.payload.activity.attachments[0].content;
			let div1 = document.createElement('div');
			div1.className = "voiceChat-mensajeRow";
			let div2 = document.createElement('div');
			div2.className = "voiceChat-confirmacionContainer";
			div1.appendChild(div2);


			let titleConfirmacion = confirmacionContent.title;
			let subtitleConfirmacion = confirmacionContent.subtitle;
			let textConfirmacion = confirmacionContent.text;
			let imagenConfirmacion = confirmacionContent.images[0].url;
			let divTitle = document.createElement('div');
			let pTitle = document.createElement('p');
			let pSubtitle = document.createElement('p');
			pTitle.innerHTML = titleConfirmacion;
			pSubtitle.innerHTML = subtitleConfirmacion;
			divTitle.appendChild(pTitle);
			divTitle.appendChild(pSubtitle);
			div2.appendChild(divTitle);
			pTitle.className = "voiceChat-confirmacionTitle";
			pSubtitle.className = "voiceChat-confirmacionSubtitle";
			divTitle.className = "voiceChat-confirmacionTitleDiv";
			let imgImagen = document.createElement('img');
			imgImagen.src = imagenConfirmacion;
			imgImagen.className = "voiceChat-confirmacionImagen";
			div2.appendChild(imgImagen);
			let divText = document.createElement('div');
			let pText = document.createElement('p');
			pText.innerHTML = textConfirmacion;
			divText.appendChild(pText);
			pText.className = "voiceChat-confirmacionText";
			divText.className = "voiceChat-confirmacionTextDiv";
			div2.appendChild(divText);


			let chatVoiceUI = document.getElementsByClassName("voiceChat-mensajes");
			chatVoiceUI[0].appendChild(div1);

		}
	}
	let voiceChatListeningOff = document.getElementsByClassName("voiceChat-listening");
	voiceChatListeningOff[0].style.display = "none";
	// let listeningVoiceBotonIcon = document.getElementsByClassName("escuchandoEnBoton");
	// listeningVoiceBotonIcon[0].style.display = "none";
	let listeningVoiceMicroIcon = document.getElementsByClassName("voiceChat-IconoVozIn");
	listeningVoiceMicroIcon[0].style.fill = "#FFFFFF";
	let listeningAvatarAnimation = document.getElementsByClassName("voiceChat-animacionAvatar");
	listeningAvatarAnimation[0].style.display = "inline";
}

//---------------------------------------------------------------------

function clearMessagesVoiceUI(user) {
	if (user === "bot") {
		let borrarMensajesBot = document.getElementsByClassName("voiceChat-mensajeRow");
		while (borrarMensajesBot.length > 0) {
			borrarMensajesBot[0].style.display = "none";
			borrarMensajesBot[0].className = " ";
		}
	} else {
		let borrarMensajesUser = document.getElementsByClassName("voiceChat-mensajeRow user");
		while (borrarMensajesUser.length > 0) {
			borrarMensajesUser[0].style.display = "none";
			borrarMensajesUser[0].className = " ";
		}
	}
}

//---------------------------------------------------------------------

function changeMicVoiceUI() {
	let micButtonStatus = document.getElementsByClassName("sr-only");
	let listeningVoiceMicroIcon = document.getElementsByClassName("voiceChat-IconoVozIn");
	let listeningAvatarAnimation = document.getElementsByClassName("voiceChat-animacionAvatar");
	let listeningVoiceUIicon = document.getElementsByClassName("voiceChat-listening");
	if (micButtonStatus[0].innerHTML.toLocaleLowerCase().includes("desactivado") || micButtonStatus[0].innerHTML.toLocaleLowerCase().includes("off")) {
		listeningVoiceUIicon[0].style.display = "flex";
		listeningVoiceMicroIcon[0].style.fill = "#eb6c6c";
		listeningAvatarAnimation[0].style.display = "none";
	} else {
		listeningVoiceUIicon[0].style.display = "none";
		listeningVoiceMicroIcon[0].style.fill = "#FFFFFF";
		listeningAvatarAnimation[0].style.display = "inline";
	}
}

//---------------------------------------------------------------------

export default () => {
	const myRef = useRef(null);

	var botonTieneListener = false;
	var textTieneListener = false;

	const [isSafari, setIsSafari] = useState(false);
	const [isIosChrome, setIsIosChrome] = useState(false);

	const [isPhone, setIsPhone] = useState(navigator.userAgent.toLowerCase().indexOf("iphone") !== -1 || navigator.userAgent.toLowerCase().indexOf("android") !== -1);

	const [directLine, setDirectLine] = useState(null);
	const [cardActionMiddleware, setCardActionMiddleware] = useState();
	const [webSpeechPonyfillFactory, setWebSpeechPonyfillFactory] = useState();
	const [origen, setOrigen] = useState();
	const [avatar, setAvatar] = useState();
	const [interfaz, setInterfaz] = useState();
	const [localeBot, setLocaleBot] = useState();
	const [initSentenceLoad, setInitSentenceLoad] = useState();
	const [runAfterAwait, setRunAfterAwait] = useState();
	const [codigoPerfil, setCodigoPerfil] = useState();
	const [tts, setTTS] = useState();

	var count = 1;
	var panonymous = "";
	var paramToken = "";
	var pnumHc = "";
	var pcodCita = "";
	var pcodPerfil = "";
	var pcodCentro = "";
	var ptipoAccion = "";
	var planguage = "es";
	var pignoreCreateUser = "";
	var pnoSuggestions = "";
	var pidAgendaDental = "";
	var pidCitaDental = "";
	var pincludeSession = "";
	var pidExpedienteVoz = "";
	var pidCitaVoz = "";
	var pcentroCitaVoz = "";
	var pencrypt = "";
	var pcentro_dental = "";
	var pespecialidad_dental = "";
	var porigen = "";
	var user = "";
	var bot = "";
	var pgeoPosition = null;
	var pcodPrestacion = "";
	var pcodEspecialidad = "";
	var pliteralPrestacion = "";
	var pliteralCentro = "";
	var pfechaInicio = "";
	var phoraInicio = "";
	var phoraFin = "";
	var pcodMedico = "";
	var pcodVerificacion = "";
	var pfb = "";
	var mensaje = "";
	var pavatar = ""; // Inicializamos un avatar por defecto
	var pParentIsIframe = "";
	var pcodEspecialidad = "";
	var pidPacDental = "";
	var pidCliDental = "";
	var pidRecallDental = "";
	var prouteIdonia = "";
	var pcodServicioBravo = "";
	var pclaveCentroDental = "";
	var pvideoConsulta = "";
	var pidCuestionario = "";
	var pidColectivo = "";
	var pidPoliza = "";
	var pidCompania = "";
	var pfirma = "";
	var piniciarCuestionario = "";
	var pidCliente = "";
	var pidentificacionCliente = "";
	var pidMediador = "";
	var pgenCOrigen = "";
	var prgpd = "";
	var pdecision = "";
	var ptelefono = "";
	var ptts = "";
	var pnombreCliente = "";
	var ptokenDental = ""
	var psaniaConnectId = "";
	var pcanal = "";
	var ptipoCita = "";
	var pidTiendaOnline = "";
	var ptokenTiendaOnline = "";
	var ptokenStiga = "";
	var papigeeToken = "";
	var porderId = "";
	var ptipoCasoUso= "";
	var ptelefonoCentro = "";
	var pdu = "";
	var pfechaNacimiento = "";
	var precordatorioAnticipado = "";
	var pcitaModificable = "";
	var pdniCliente = "";
	var pdniMedico = "";
	var pidChequeo = "";
	var ptokenChequeo = "";
	var papellidosCliente = "";
	var phuecos = "";
	var pdireccion = "";
	var phuecos = "";
	var ppaginas = "";
	var pdespedida = "";
	var pidWebhookWhatsapp = "";
	var pkeepContext = "";
	var pemail_bravo = "";
	var ppredict = "";
	var ptiempoEspera = "";
	var psaniaChat = "";
	var pmodel = "";
	var pcodTarjeta = "";
	var pagr = "";
	var pciudad = "";
	var pversion = "";
	var pcodConsulta="";
	var pnombreMedico = "";
	var punidadNegocio = "";
	var pwhatsappParams = "";
	var puseRag = "";

	// EVENTO AL PULSAR 'ENTER' EN EL INPUT TEXT DEL SENDBOX
	async function handleTextboxKeypress(e) {
		const node = ReactDOM.findDOMNode(myRef.current);
		var campoTexto = node.querySelector('input[data-id="webchat-sendbox-input"]');
		if (campoTexto && campoTexto.value && campoTexto.value.trim().length > 0 && e.key === 'Enter') {
			const node = ReactDOM.findDOMNode(myRef.current);
			let sendButton = node.querySelector('button[data-id="webchat-sendbox-send-button"]');
			sendButton.style.visibility = 'hidden';
			hiddenButtonAfterUserInput();
			hiddenButtonAfterUserInputVoiceUI();
		}
	}

	// EVENTO AL HACER 'CLIC' EN EL BOTON DE ENVIAR MENSAJE DEL SENDBOX
	async function handleSendButtonKey(e) {
		const node = ReactDOM.findDOMNode(myRef.current);
		let sendButton = node.querySelector('button[data-id="webchat-sendbox-send-button"]');
		sendButton.style.visibility = 'hidden';
		hiddenButtonAfterUserInput();
		hiddenButtonAfterUserInputVoiceUI();
	}

	// EVENTO CADA VEZ QUE PULSAMOS TECLA EN EL INPUT TEXT DEL SENDBOX
	async function handleTextboxKeyup(e) {
		//console.log("KEYUP");

		const node = ReactDOM.findDOMNode(myRef.current);

		var campoTexto = node.querySelector('input[data-id="webchat-sendbox-input"]');

		if (campoTexto && campoTexto.readOnly) {
			campoTexto.readOnly = false;
		}

		var sendButton = node.querySelector('button[data-id="webchat-sendbox-send-button"]');

		if (campoTexto && campoTexto.value && campoTexto.value.trim().length > 0) {
			sendButton.style.visibility = 'visible';
		}
		else {
			sendButton.style.visibility = 'hidden';
		}
	}

	const store = useMemo(
		() =>
			createStore({}, ({ dispatch }) => next => action => {
				// if (action.payload) console.log(action.payload.activity);
				// console.log("ACTION.TYPE: " + action.type);

				// ROLE INJECT PROTECTION
				if (action.payload && action.payload.activity && action.payload.activity.recipient && action.payload.activity.from && action.payload.activity.from.role != "user") {
					action.payload.activity.from.role = "user";
				}

				// SITUAMOS EL SCROLL EN EL ULTIMO MENSAJE (EN CASO NECESARIO)
				let buttonSetScroll = document.querySelector("li.webchat__scrollToEndButton"); //webchat__scrollToEndButton css-1swcjrc
				let ulMessages = document.querySelector('ul[role="list"]');
				let heightMessages = ulMessages ? ulMessages.scrollHeight : null;
				let heightContainer = ulMessages && ulMessages.parentElement && ulMessages.parentElement.parentElement ? ulMessages.parentElement.parentElement.scrollHeight : null;
				if (buttonSetScroll && heightMessages && heightContainer && heightMessages > heightContainer) { buttonSetScroll.click(); }

				if (action.type === 'DIRECT_LINE/CONNECT_FULFILLED') {

					// AVATAR
					if (pavatar !== "" && pavatar !== null && pavatar !== undefined) {
						document.querySelector("#silence1").addEventListener('ended', function _func() {
							document.querySelector("#silence1").removeEventListener('ended', _func);
							changeVideo(null, 0); // Silence
						});
					} else {
						// SPEAKER
						let speaker = document.querySelector('.speaker');
						speaker.addEventListener('click', function (e) {
							e.preventDefault();
							if (saniaSpeak) { stopSaniaSpeech(); }
							saniaSpeak = saniaSpeak == true ? false : true;
							if (saniaSpeak) {
								speaker.src = "./img/volumen-on.svg";
							} else {
								speaker.src = "./img/volumen-off.svg";
							}
						});
						$('.speaker').click(); // DESACTIVAMOS POR DEFECTO

						// CLOSE BUTTON FLOTANTE --> MOVEMOS EL SPEAKER
						if (pParentIsIframe === "true") {
							speaker.style.marginRight = "50px";
						}

						// Asignamos el evento onclick al botton de llamada SOS
						document.getElementById('callSosButton').addEventListener('click', function () {
							let messageSosBrabu = "Quiero que me llames";
							if (planguage === "en") messageSosBrabu = "I want you call me";
							else if (planguage === "ca") messageSosBrabu = "Vull que em truquis";
							else if (planguage === "de") messageSosBrabu = "Ich möchte, dass du mich anrufst";
							else if (planguage === "fr") messageSosBrabu = "Je veux que tu m'appelles";
							store.dispatch(setSendBox(messageSosBrabu));
							store.dispatch(submitSendBox());
						}, true);
					}


					// SE DESHABILITA EL SENDBOX
					let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
					if (campoTexto) campoTexto.style.visibility = 'hidden';

					// ADD EVENTS AL INTERACTUAR CON EL SENDTEXTBOX, SENDBUTTON Y MICBUTTON
					if (campoTexto) {
						campoTexto.addEventListener("keypress", handleTextboxKeypress);
						campoTexto.addEventListener("keyup", handleTextboxKeyup);
					}
					let sendButton = document.querySelector('button[data-id="webchat-sendbox-send-button"]');
					if (sendButton) sendButton.addEventListener("click", handleSendButtonKey);
					let micButton = document.querySelector('[aria-controls="webchatSendBoxMicrophoneButton"]');
					if (micButton) {
						// Activamos/desactivamos el css relacionado con el microfono activo en la interfaz por voz
						micButton.children[0].onclick = function () {
							changeMicVoiceUI();
						}
					}

					dispatch({
						type: 'WEB_CHAT/SEND_EVENT',
						payload: {
							from: user,
							name: 'requestWelcomeDialog',
							type: 'event',
							value: JSON.stringify(mensaje)
						}
					});

					if (!isSafari) {
						firstInteractionUser = true;
						initAudioContext();
					} else {
						// EVENTO PARA CREAR EL CONTEXTO DE AUDIO
						document.getElementById('app').addEventListener('click', initAudioContext, true);
						document.getElementById('app').addEventListener('keypress', initAudioContext, true);
					}

				}

				if (action.type === 'WEB_CHAT/SET_SUGGESTED_ACTIONS') {
					if(parametersSent){
						parametersSent = false;
						cleanParameters();
					}
					//console.log("WEB_CHAT/SET_SUGGESTED_ACTIONS");
				}

				if (action.type === 'WEB_CHAT/START_SPEAKING') {
					//console.log("action.type === WEB_CHAT/STOP_SPEAKING");
				}

				if (action.type === 'WEB_CHAT/STOP_SPEAKING') {
					//console.log("action.type === WEB_CHAT/STOP_SPEAKING");
				}

				if (action.type === 'WEB_CHAT/START_DICTATE') {
					//console.log("action.type === WEB_CHAT/START_DICTATE");
					stopSaniaSpeech();
				}

				if (action.type === 'WEB_CHAT/SEND_FILES' && action.payload && action.payload.files){
					for(let file of action.payload.files){
						if(file.size >= 4194304){
							let base64Image = file.thumbnail;
							if(base64Image.indexOf("image") > 0) {
								var img = new Image();
								img.onload = function resizeImage() {
									let canvas = document.createElement('canvas'), ctx = canvas.getContext('2d');
									let newWidth = img.naturalWidth > 1920 ? img.naturalWidth / 2 : img.naturalWidth;
									let newHeight = img.naturalHeight > 1080 ? img.naturalHeight / 2 : img.naturalHeight;
									canvas.width = newWidth;
									canvas.height = newHeight;
									ctx.drawImage(img, 0, 0, newWidth, newHeight);
									let dataURL = canvas.toDataURL('image/jpeg', 1.0);
									let resizedImgBuffer = new Buffer.from(dataURL);
									let byteString = atob(dataURL.split(',')[1]);
									let ab = new ArrayBuffer(byteString.length);
									let ia = new Uint8Array(ab);
									for (let i = 0; i < byteString.length; i++) {
										ia[i] = byteString.charCodeAt(i);
									}
									let blob = new Blob([ab], { type: 'image/jpeg' });
									let file_payload = {
										name: "Archivo Subido",
										size: Buffer.byteLength(resizedImgBuffer, 'base64'), 
										//thumbnail: dataURL,
										url: URL.createObjectURL(blob)
									}
									store.dispatch({
										type: 'WEB_CHAT/SEND_FILES',
										payload: {files: [file_payload]}
									});
								};
								img.src = base64Image;
								action.payload.files=[]
							}
						}
					}
				}

				if (action.type === 'WEB_CHAT/SET_DICTATE_INTERIMS') {
					//console.log('action.type === WEB_CHAT/SET_DICTATE_INTERIMS');
					textTieneListener = false;
					botonTieneListener = false;
				}

				if (action.type === 'WEB_CHAT/STOP_DICTATE') {
					//console.log('action.type === WEB_CHAT/STOP_DICTATE');

					const node = ReactDOM.findDOMNode(myRef.current);
					var sendButton = node.querySelector('button[data-id="webchat-sendbox-send-button"]');
					if (sendButton) {
						if (!botonTieneListener) {
							sendButton.addEventListener("click", () => {
								const nodeInicio = ReactDOM.findDOMNode(myRef.current);
								var inputText = nodeInicio.querySelector('input[data-id="webchat-sendbox-input"]');
								if (inputText.value) {
									store.dispatch({
										type: 'WEB_CHAT/SUBMIT_SEND_BOX',
										payload: { method: 'keyboard' }
									});
								}
							});

							botonTieneListener = true;
						}
					}
				}

				if (action.type === 'WEB_CHAT/SET_SEND_BOX') {
					// Al pulsar el microfono para hablar Webchat elimina los eventos asociados al sendBox
					let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
					// ADD EVENTS AL INTERACTUAR CON EL SENDTEXTBOX, SENDBUTTON Y MICBUTTON
					if (campoTexto) {
						campoTexto.addEventListener("keypress", handleTextboxKeypress);
						campoTexto.addEventListener("keyup", handleTextboxKeyup);
					}
				}

				if (action.type === 'DIRECT_LINE/POST_ACTIVITY'){
					if(action.payload.activity.text && action.payload.activity.text.includes("@PARAMETERS@")){
						parametersSent = true;
					}
				}
				if (action.type === 'DIRECT_LINE/POST_ACTIVITY_FULFILLED') {

					// Margen para visualizar el primer mensaje con el scroll
					let firstMessage = document.querySelector('ul[role="list"]').firstChild;
					if (firstMessage) firstMessage.style.marginTop = "50px";

					const node = ReactDOM.findDOMNode(myRef.current);

					// CATCH CHECKBOX
					let containerAdaptiveCard = node.querySelectorAll('div.ac-container.ac-adaptiveCard');
					if (containerAdaptiveCard.length > 0 && JSON.stringify(containerAdaptiveCard[0].innerHTML).indexOf("ac-choiceSetInput-multiSelect") >= 0) {
						containerAdaptiveCard[0].style.border = "2px solid #8fc4e7";
						containerAdaptiveCard[0].style.borderRadius = "12px";
					}

					// SE BORRA EL TEXTO DEL SENDBOX
					let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
					let wcPanelText = document.getElementsByClassName("wc-chatview-panel");
					if (campoTexto && wcPanelText && wcPanelText[0].style.visibility !== "hidden") {
						store.dispatch(setSendBox(""));
					}

					var sendButton02 = node.querySelector('button[data-id="webchat-sendbox-send-button"]');
					sendButton02.style.visibility = 'hidden';

					// OCULTAR SENDTYPING VOICE
					let sendTypingVoice = document.getElementById('voiceSendTyping');
					if (sendTypingVoice) { sendTypingVoice.style.display = 'none'; }

					// PINTAR LA CARD DE LOGIN LLEVA UN TIEMPO Y ES NECESARIO ESPERAR PARA CONVERTIR EL CAMPO A TYPE PASSWORD
					setTimeout(() => {

						// SE HABILITA EL TEXTO DEL SENDBOX
						if (campoTexto && wcPanelText && wcPanelText[0].style.visibility !== "hidden") {
							campoTexto.style.visibility = 'visible';
							if (!isPhone) { campoTexto.focus(); }
						}

						//Cuando el usuario haya enviado el mensaje SendBox pierde el foco para que en Android se cierre el teclado (?????)
						//document.querySelector('#webchat > *').blur();				
						if (isPhone) {
							if (campoTexto) {
								campoTexto.blur();
							}
						}

						// CAMBIAMOS A TYPE PASSWORD EL INPUT TEXT PASSWORD DEL LOGIN Y REALIZAMOS MANUALMENTE EL POSTBACK
						let containerLogin = document.getElementsByClassName("ac-container ac-adaptiveCard");
						if (containerLogin && containerLogin.length > 0 && containerLogin[0].children.length > 8 && containerLogin[0].children[4].innerText.toLocaleLowerCase().trim() === "contraseña") {
							containerLogin[0].children[6].children[0].innerHTML = containerLogin[0].children[6].children[0].innerHTML.replace("text", "password");
							containerLogin[0].children[8].children[0].children[0].children[0].onclick = function () {
								let value = { user: containerLogin[0].children[2].children[0].children[0].value, password: containerLogin[0].children[6].children[0].children[0].value };
								store.dispatch(sendPostback(value));
							}
						}

					}, 100);

					// SI PINTAMOS UNA ADAPTIVE CARD, EL PRIMER ACTION SET SE LE HACE CLICK
					setTimeout(() => {updateAvailabilitiesFirstButton();}, 100);
					

				}

				if (action.type === 'DIRECT_LINE/INCOMING_ACTIVITY' && action.payload.activity.from.id === id_sania_webchat && action.payload.activity.type === 'message') {
					// CATCH EVENTO ADOBE TRAZABILIDAD (Arturo)
					if (action.payload.activity.text) action.payload.activity.text = applyXssProtection(action.payload.activity.text);
					if (action.payload.activity.text && action.payload.activity.text.includes("ADOBE_EVENT")) {
						let dataAdobeEvent = action.payload.activity.text.split("ADOBE_EVENT:");
						action.payload.activity.text = dataAdobeEvent[0];
						let dataToLaunchAdobeEvent = new Object();
						// COTIZADOR SEGUROS
						if (dataAdobeEvent[1] == "inicioCotizadorSeguros") {
							window.idAdobeEvent = generateUniqueId();
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": null
										}
									},
									"interacciones": {
										"evento": "chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": null
										},
										"estado": "iniciado",
										"nombrePaso": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "inicioCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": null
										},
										"estado": "iniciado",
										"nombrePaso": "datos empresa"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "tramosCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": null
										},
										"estado": null,
										"nombrePaso": "numero empleados"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1].includes("respuestaTramosCotizacionSeguros")) {
							window.nPersonasCotizadorSeguros = dataAdobeEvent[1].split(".")[1];
						} else if (dataAdobeEvent[1] == "coberturaCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": window.nPersonasCotizadorSeguros
										},
										"estado": null,
										"nombrePaso": "coberturas"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "copagosCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": window.nPersonasCotizadorSeguros
										},
										"estado": null,
										"nombrePaso": "copagos"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "cifCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": window.nPersonasCotizadorSeguros
										},
										"estado": null,
										"nombrePaso": "cif"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "precioCotizacionSeguros") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat"
										}
									},
									"interacciones": {
										"evento": "cotizacion chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"asegurado": {
											"numeroAsegurados": window.nPersonasCotizadorSeguros
										},
										"estado": "finalizado",
										"nombrePaso": "precio final"
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						}
						// PETICION CITA DENTAL
						else if (dataAdobeEvent[1] == "inicioPedirCitaDental") {
							window.idAdobeEvent = generateUniqueId();
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": null,
											"categoriaPagina": null
										}
									},
									"interacciones": {
										"evento": "chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": "iniciado",
										"especialidad": null,
										"busquedaCita": null,
										"modalidad": null,
										"tipoCita": null,
										"idCentro": null,
										"producto": null,
										"nombrePaso": null,
										"idCita": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "especialidadPedirCitaDental") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat",
											"categoriaPagina": "cita online"
										}
									},
									"interacciones": {
										"evento": "cita dental chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": "iniciado",
										"especialidad": null,
										"busquedaCita": "chat",
										"modalidad": "presencial",
										"tipoCita": "dental",
										"idCentro": pclaveCentroDental.length > 0 ? pclaveCentroDental : null,
										"producto": "cita dental",
										"nombrePaso": "seleccion especialidad",
										"idCita": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1].includes("fechaPedirCitaDental")) {
							window.prestacionCitaDental = dataAdobeEvent[1].split("=")[1];
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat",
											"categoriaPagina": "cita online"
										}
									},
									"interacciones": {
										"evento": "cita dental chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": null,
										"especialidad": window.prestacionCitaDental,
										"busquedaCita": "chat",
										"modalidad": "presencial",
										"tipoCita": "dental",
										"idCentro": pclaveCentroDental.length > 0 ? pclaveCentroDental : null,
										"producto": "cita dental",
										"nombrePaso": "calendario",
										"idCita": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "huecosPedirCitaDental") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat",
											"categoriaPagina": "cita online"
										}
									},
									"interacciones": {
										"evento": "cita dental chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": null,
										"especialidad": window.prestacionCitaDental,
										"busquedaCita": "chat",
										"modalidad": "presencial",
										"tipoCita": "dental",
										"idCentro": pclaveCentroDental.length > 0 ? pclaveCentroDental : null,
										"producto": "cita dental",
										"nombrePaso": "hora",
										"idCita": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1] == "nuevoUsuarioPedirCitaDental") {
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat",
											"categoriaPagina": "cita online"
										}
									},
									"interacciones": {
										"evento": "cita dental chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": null,
										"especialidad": window.prestacionCitaDental,
										"busquedaCita": "chat",
										"modalidad": "presencial",
										"tipoCita": "dental",
										"idCentro": pclaveCentroDental.length > 0 ? pclaveCentroDental : null,
										"producto": "cita dental",
										"nombrePaso": "datos personales",
										"idCita": null
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						} else if (dataAdobeEvent[1].includes("confirmacionCitaPedirCitaDental")) {
							window.codCitaDental = dataAdobeEvent[1].split("=")[1];
							dataToLaunchAdobeEvent = {
								"eventType": "chat-interaction",
								"digitalData": {
									"pagina": {
										"info": {
											"tipologiaPagina": "chat",
											"categoriaPagina": "cita online"
										}
									},
									"interacciones": {
										"evento": "cita dental chat"
									},
									"proceso": {
										"idProceso": window.idAdobeEvent,
										"estado": "finalizado",
										"especialidad": window.prestacionCitaDental,
										"busquedaCita": "chat",
										"modalidad": "presencial",
										"tipoCita": "dental",
										"idCentro": pclaveCentroDental.length > 0 ? pclaveCentroDental : null,
										"producto": "cita dental",
										"nombrePaso": "confirmacion",
										"idCita": window.codCitaDental
									}
								}
							};
							// console.log(dataToLaunchAdobeEvent);
							window.parent.window.postMessage(dataToLaunchAdobeEvent, '*');
						}
					}

					// EVENTO PRUEBAS PARA INTEGRARNOS CON APP SPS (FABIAN)
					// console.log(window.eventMiSanitas);
					document.dispatchEvent(window.eventMiSanitas);
					window.top.postMessage('sania', '*');

					// EVENTO PARA LANZAR ANURA-BRABU DESDE APP (RUBEN SALUD_CONECTADA)
					if (action.payload.activity.text && action.payload.activity.text.includes("<abrirAnura>")) {
						action.payload.activity.text = "";
						document.dispatchEvent(window.eventBrabu);
						window.top.postMessage('anura', '*');
					}

					// Limpiamos los mensajes del usuario de la interfaz de voz
					clearMessagesVoiceUI("user");

					// Pintamos los mensajes del bot en la interfaz por voz
					writeMessageVoiceUI("bot", action, store);

					// Console log para imprimir los JSON en pantalla
					// console.log("ACTION: " + JSON.stringify(action));

					// CATCH EVENTO FACEBOOK
					if (action.payload.activity.text && action.payload.activity.text.includes("FACEBOOK_EVENT")) {
						let dataFacebookEvent = action.payload.activity.text.split("FACEBOOK_EVENT:");
						// action.payload.activity.eventFacebook = dataFacebookEvent[1].trim();
						action.payload.activity.text = dataFacebookEvent[0];
					}

					// CATCH EVENTO SANIA
					if (action.payload.activity.text && action.payload.activity.text.includes("SANIA_EVENT")) {
						let saniaEvent = action.payload.activity.text.split("SANIA_EVENT:");
						action.payload.activity.saniaEvent = saniaEvent[1].trim();
						action.payload.activity.text = saniaEvent[0];

						if(saniaEvent[1].includes("&data=")){
							let data = JSON.parse(saniaEvent[1].split("&data=")[1])
							window.top.postMessage(data, '*');
						}
						else{
							//console.log("EVENTO SANIA PAGINA PADRE "+saniaEvent[1].trim())
							window.top.postMessage(saniaEvent[1].trim(), '*');
						}
					}

					if (action.payload.activity.text && action.payload.activity.text.includes("SHOW_FILE_UPLOAD")) {
						let fileUploadEvent = action.payload.activity.text.split("SHOW_FILE_UPLOAD");
						action.payload.activity.fileUploadEvent = fileUploadEvent[1].trim();
						action.payload.activity.text = fileUploadEvent[0];

						let fileUploadButton = document.getElementsByClassName("css-10kaz4p")
						if(fileUploadButton && fileUploadButton.length > 0){
							fileUploadButton[0].style.display = "block" 
						}
					}

					if (action.payload.activity.text && action.payload.activity.text.includes("HIDE_FILE_UPLOAD")) {
						let fileUploadEvent = action.payload.activity.text.split("HIDE_FILE_UPLOAD");
						action.payload.activity.fileUploadEvent = fileUploadEvent[1].trim();
						action.payload.activity.text = fileUploadEvent[0];

						let fileUploadButton = document.getElementsByClassName("css-10kaz4p")
						if(fileUploadButton && fileUploadButton.length > 0){
							fileUploadButton[0].style.display = "none" 
						}
					}

					// SPEAK AVATAR
					let textoParaSintesis = null;
					if (firstInteractionUser && saniaSpeak && action.payload.activity.text && action.payload.activity.text.length > 0) { // Texto de mensaje bubble
						textoParaSintesis = action.payload.activity.text;
					} else if (firstInteractionUser && saniaSpeak && action.payload.activity.attachments && action.payload.activity.attachments.length > 0 && action.payload.activity.attachments[0].content.body && action.payload.activity.attachments[0].content.body.length > 0 && action.payload.activity.attachments[0].content.body[0].text) { // Mensaje de card
						textoParaSintesis = action.payload.activity.attachments[0].content.body[0].text;
					}
					// if (action.payload) console.log(JSON.stringify(action.payload.activity))
					if (textoParaSintesis) {
						let textToSpeak = removeStrangeCharacters(textoParaSintesis).replace("xxxxx", "");
						if (arraySynthesisPhrases.length == 0) {
							arraySynthesisPhrases.push(textToSpeak);
							saniaSpeech(null, pavatar, planguage, ptts);
						} else {
							arraySynthesisPhrases.push(textToSpeak);
						}
					}

					//GENERAR UN EVENTO JAVASCRIPT CADA VEZ QUE LLEGA UN MENSAJE DEL BOT
					const event = new Event('webchatincomingactivity');
					event.data = action.payload.activity;
					window.dispatchEvent(event);

				}

				if (action.type === 'WEB_CHAT/SUBMIT_SEND_BOX' || action.type === 'WEB_CHAT/SEND_MESSAGE' || action.type === "WEB_CHAT/SEND_POST_BACK") {

					// Evitamos inyeccion de codigo
					let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
					if (campoTexto && campoTexto.value) {
						let inputUser = removeStrangeCharacters(campoTexto.value);
						store.dispatch(setSendBox(inputUser));
						campoTexto.setAttribute('value', inputUser);
					}

					// Paramos la sintesis de voz de amazon
					stopSaniaSpeech();

					// Limpiamos los mensajes (con botones incluidos) de la interfaz de voz
					clearMessagesVoiceUI("bot");

					// Ocultamos los botones de ambas interfaces UI
					if (action.payload && (action.payload.value || (action.payload.text && action.payload.text.trim().length > 0 && action.payload.text.replace('á', 'a').toLowerCase().trim() !== 'mas' && action.payload.text.toLowerCase().trim() !== 'more'))) {
						hiddenButtonAfterUserInput();
						hiddenButtonAfterUserInputVoiceUI();
					}

					// Escribimos en la UI por voz
					if (action.type === 'WEB_CHAT/SEND_MESSAGE') { writeMessageVoiceUI("user", action, store); }

					// PERMITE COMPROBAR LA PRIMERA INTERACCION DE USUARIO PARA UTILIZAR EL AUDIOCONTEXT
					if (!firstInteractionUser) {
						firstInteractionUser = true;
						// ELIMINAMOS EL EVENTO DE INICIALIZACION DEL AUDIO CONTEXT
						document.getElementById('app').removeEventListener('click', initAudioContext, true);
						document.getElementById('app').removeEventListener('keypress', initAudioContext, true);
					}

					// Comprobamos la UI ejecutada (Voz/Texto)
					let wcPanelText = document.getElementsByClassName("wc-chatview-panel");
					if (wcPanelText[0].style.visibility === "visible") {
						// Evitar que se bloque el sendBox cuando un usuario escribe espacios en blanco
						if (action.payload && action.payload.text && action.payload.text.trim().length > 0) {
							// SE DESHABILITA EL SENDBOX
							if (campoTexto) campoTexto.style.visibility = 'hidden';
							// SE HABILITA EL SENDBOX A LOS 30'
							setTimeout(
								function () {
									if (campoTexto && campoTexto.style.visibility === 'hidden') {
										campoTexto.style.visibility = 'visible';
									}
								}
									.bind(this),
								30000
							);
						}
					} else {
						// MOSTRAMOS SENDTYPING VOICE
						let sendTypingVoice = document.getElementById('voiceSendTyping');
						if (sendTypingVoice) { sendTypingVoice.style.display = 'inline'; }
					}

					// ELIMINAMOS LA CARD DE LOGIN
					let containerLogin = document.getElementsByClassName("ac-container ac-adaptiveCard");
					if (containerLogin && containerLogin.length > 0 && containerLogin[0].children.length > 6 && containerLogin[0].children[4].innerText.toLocaleLowerCase().trim() === "contraseña") {
						$(".ac-container.ac-adaptiveCard").remove();
					}

				}

				return next(action);
			}),
		[]
	);


	useEffect(
		async () => {
			await setCredentials();

			async function getDirectLineToken() {
			
				const res = await fetch('https://europe.directline.botframework.com/v3/directline/tokens/generate', {
					headers: {
						authorization: 'Bearer ' + secret_directline
					},
					method: 'POST'
				});
				const { token } = await res.json();
				//console.log("DIRECTLINE TOKEN:" + token);

				return token;
			}

			var browser = get_browser();

			/* PARA ENVIAR MENSAJE DE INICIALIZACI�N AL BOT */
			var urlParams = new URLSearchParams(window.location.search);
			var acceso_bot = false;

			if (browser.name === 'IE') {
				window.alert("Lo siento, pero Internet Explorer no esta soportado. Por favor utilice Chrome o cualquier otro navegador");
				window.location.href = "https://www.google.com/intl/es/chrome/";
			} else {

				if (urlParams !== null) {

					if (urlParams.has("token")) {
						paramToken = urlParams.get("token");
					}

					if (urlParams.has("anonymous")) {
						panonymous = urlParams.get("anonymous");
					}

					if (urlParams.has("numHc")) {
						pnumHc = urlParams.get("numHc");
					}

					if (urlParams.has("codCita")) {
						pcodCita = urlParams.get("codCita");
					}

					if (urlParams.has("codPerfil")) {
						pcodPerfil = urlParams.get("codPerfil");
					}

					if (urlParams.has("codCentro")) {
						pcodCentro = urlParams.get("codCentro");
					}

					if (urlParams.has("tipoAccion")) {
						ptipoAccion = urlParams.get("tipoAccion");
					}

					if (urlParams.has("language")) {
						planguage = urlParams.get("language");
						if (planguage != "es" && planguage != "en" && planguage != "ca" && planguage != "pt" && planguage != "de") planguage = "es"; // Determinamos los idiomas aceptados
					}

					if (urlParams.has("ignoreCreateUser")) {
						pignoreCreateUser = urlParams.get("ignoreCreateUser");
					}

					if (urlParams.has("noSuggestions")) {
						pnoSuggestions = urlParams.get("noSuggestions");
					}

					if (urlParams.has("idAgendaDental")) {
						pidAgendaDental = urlParams.get("idAgendaDental");
					}

					if (urlParams.has("idCitaDental")) {
						pidCitaDental = urlParams.get("idCitaDental");
					}

					if (urlParams.has("includeSession")) {
						pincludeSession = urlParams.get("includeSession");
					}

					if (urlParams.has("idExpedienteVoz")) {
						pidExpedienteVoz = urlParams.get("idExpedienteVoz");
					}

					if (urlParams.has("idCitaVoz")) {
						pidCitaVoz = urlParams.get("idCitaVoz");
					}

					if (urlParams.has("centroCitaVoz")) {
						pcentroCitaVoz = urlParams.get("centroCitaVoz");
					}

					if (urlParams.has("geoposition")) {
						pgeoPosition = urlParams.get("geoposition");
					}

					if (urlParams.has("encrypt")) {
						pencrypt = urlParams.get("encrypt");
					}

					if (urlParams.has("centro_dental")) {
						pcentro_dental = urlParams.get("centro_dental");
					}

					if (urlParams.has("especialidad_dental")) {
						pespecialidad_dental = urlParams.get("especialidad_dental");
					}

					if (urlParams.has("origen")) {
						porigen = urlParams.get("origen");
					}

					if (urlParams.has("codPrestacion")) {
						pcodPrestacion = urlParams.get("codPrestacion");
					}

					if (urlParams.has("codEspecialidad")) {
						pcodEspecialidad = urlParams.get("codEspecialidad")
					}

					if (urlParams.has("literalPrestacion")) {
						pliteralPrestacion = urlParams.get("literalPrestacion");
					}

					if (urlParams.has("literalCentro")) {
						pliteralCentro = urlParams.get("literalCentro");
					}

					if (urlParams.has("fechaInicio")) {
						pfechaInicio = urlParams.get("fechaInicio");
					}

					if (urlParams.has("horaInicio")) {
						phoraInicio = urlParams.get("horaInicio");
					}

					if (urlParams.has("horaFin")) {
						phoraFin = urlParams.get("horaFin");
					}


					if (urlParams.has("codMedico")) {
						pcodMedico = urlParams.get("codMedico");
					}

					if (urlParams.has("codVerificacion")) {
						pcodVerificacion = urlParams.get("codVerificacion");
					}

					if (urlParams.has("fb")) {
						pfb = urlParams.get("fb");
					}

					if (urlParams.has("avatar")) {
						pavatar = urlParams.get("avatar");
					}

					if (urlParams.has("parentIsIframe")) {
						pParentIsIframe = urlParams.get("parentIsIframe");
					}

					if (urlParams.has("codEspecialidad")) {
						pcodEspecialidad = urlParams.get("codEspecialidad");
					}

					if (urlParams.has("idPacDental")) {
						pidPacDental = urlParams.get("idPacDental");
					}

					if (urlParams.has("idCliDental")) {
						pidCliDental = urlParams.get("idCliDental");
					}

					if (urlParams.has("idRecallDental")) {
						pidRecallDental = urlParams.get("idRecallDental");
					}

					if (urlParams.has("routeIdonia")) {
						prouteIdonia = urlParams.get("routeIdonia");
					}

					if (urlParams.has("codServicioBravo")) {
						pcodServicioBravo = urlParams.get("codServicioBravo");
					}

					if (urlParams.has("claveCentroDental")) {
						pclaveCentroDental = urlParams.get("claveCentroDental");
					}

					if (urlParams.has("videoConsulta")) {
						pvideoConsulta = urlParams.get("videoConsulta");
					}

					if (urlParams.has("idCuestionario")) {
						pidCuestionario = urlParams.get("idCuestionario");
					}

					if (urlParams.has("idColectivo")) {
						pidColectivo = urlParams.get("idColectivo");
					}

					if (urlParams.has("idPoliza")) {
						pidPoliza = urlParams.get("idPoliza");
					}

					if (urlParams.has("idCompania")) {
						pidCompania = urlParams.get("idCompania");
					}

					if (urlParams.has("firma")) {
						pfirma = urlParams.get("firma");
					}

					if (urlParams.has("iniciarCuestionario")) {
						piniciarCuestionario = urlParams.get("iniciarCuestionario");
					}

					if (urlParams.has("idCliente")) {
						pidCliente = urlParams.get("idCliente");
					}

					if (urlParams.has("identificacionCliente")) {
						pidentificacionCliente = urlParams.get("identificacionCliente");
					}

					if (urlParams.has("idMediador")) {
						pidMediador = urlParams.get("idMediador");
					}

					if (urlParams.has("genCOrigen")) {
						pgenCOrigen = urlParams.get("genCOrigen");
					}

					if (urlParams.has("rgpd")) {
						prgpd = urlParams.get("rgpd");
					}

					if (urlParams.has("decision")) {
						pdecision = urlParams.get("decision");
					}

					if (urlParams.has("telefono")) {
						ptelefono = urlParams.get("telefono");
					}

					if (urlParams.has("tts")) {
						ptts = urlParams.get("tts");
					}

					if (urlParams.has("nombreCliente")) {
						pnombreCliente = urlParams.get("nombreCliente");
					}

					if (urlParams.has("tokenDental")) {
						ptokenDental = urlParams.get("tokenDental");
					}

					if (urlParams.has("saniaConnectId")) {
						psaniaConnectId = urlParams.get("saniaConnectId");
					}

					if (urlParams.has("canal")) {
						pcanal = urlParams.get("canal");
					}

					if (urlParams.has("tipoCita")) {
						ptipoCita = urlParams.get("tipoCita");
					}

					if (urlParams.has("idTiendaOnline")) {
						pidTiendaOnline = urlParams.get("idTiendaOnline");
					}

					if (urlParams.has("tokenTiendaOnline")) {
						ptokenTiendaOnline = urlParams.get("tokenTiendaOnline");
					}

					if (urlParams.has("tokenStiga")) {
						ptokenStiga = urlParams.get("tokenStiga");
					}

					if (urlParams.has("apigeeToken")) {
						papigeeToken = urlParams.get("apigeeToken");
					}

					if(urlParams.has("orderId")){
						porderId = urlParams.get("orderId");
					}

					if(urlParams.has("pwhatsappParams")){
						pwhatsappParams = urlParams.get("pwhatsappParams");
					}

					if(urlParams.has("mascotas")){
						pmascotas= urlParams.get("mascotas");
					}
					
					if(urlParams.has("tipoCasoUso")){
						ptipoCasoUso= urlParams.get("tipoCasoUso");
					}

					if(urlParams.has("telefonoCentro")){
						ptelefonoCentro = urlParams.get("telefonoCentro");
					}
					
					if(urlParams.has("du")){
						pdu = urlParams.get("du");
					}

					if(urlParams.has("fechaNacimiento")){
						pfechaNacimiento = urlParams.get("fechaNacimiento");
					}

					if(urlParams.has("recordatorioAnticipado")){
						precordatorioAnticipado = urlParams.get("recordatorioAnticipado");
					}

					if(urlParams.has("citaModificable")){
						pcitaModificable = urlParams.get("citaModificable");
					}

					if(urlParams.has("dniCliente")){
						pdniCliente = urlParams.get("dniCliente");
					}

					if(urlParams.has("dniMedico")){
						pdniMedico = urlParams.get("dniMedico");
					}

					if(urlParams.has("idChequeo")){
						pidChequeo = urlParams.get("idChequeo");
					}

					if(urlParams.has("tokenChequeo")){
						ptokenChequeo = urlParams.get("tokenChequeo");
					}

					if(urlParams.has("apellidosCliente")){
						papellidosCliente = urlParams.get("apellidosCliente");
					}

					if(urlParams.has("huecos")){
						phuecos = urlParams.get("huecos");
					}

					if(urlParams.has("direccion")){
						pdireccion = urlParams.get("direccion");
					}
					
					if(urlParams.has("paginas")){
						ppaginas = urlParams.get("paginas");
					}

					if(urlParams.has("despedida")){
						pdespedida = urlParams.get("despedida");
					}

					if(urlParams.has("idWebhookWhatsapp")){
						pidWebhookWhatsapp = urlParams.get("idWebhookWhatsapp");
					}

					if(urlParams.has("keepContext")){
						pkeepContext = urlParams.get("keepContext");
					}

					if(urlParams.has("email_bravo")){
						pemail_bravo = urlParams.get("email_bravo");
					}

					if(urlParams.has("predict")){
						ppredict = urlParams.get("predict");
					}

					if(urlParams.has("tiempoEspera")){
						ptiempoEspera = urlParams.get("tiempoEspera");
					}

					if(urlParams.has("saniaChat")){
						psaniaChat = urlParams.get("saniaChat");
					}		
					
					if(urlParams.has("model")){
						pmodel = urlParams.get("model");
					}

					if(urlParams.has("codTarjeta")){
						pcodTarjeta = urlParams.get("codTarjeta");
					}

					if(urlParams.has("agr")){
						pagr = urlParams.get("agr");
					}

					if(urlParams.has("ciudad")){
						pciudad = urlParams.get("ciudad");
					}

					if(urlParams.has("version")){
						pversion = urlParams.get("version");
						if (pversion == "2") { // WEBAPP SANIA CHAT
							secret_directline = process.env.REACT_APP_DIRECTLINE_AUTHORIZATION_SANIACHAT;
							id_sania_webchat = process.env.REACT_APP_ID_SANIA_WEBCHAT_SANIACHAT;
							endpoint_webapp = process.env.REACT_APP_ENDPOINT_WEB_APP_SANIACHAT;
						}
					}

					if (urlParams.has("codConsulta")){
						pcodConsulta = urlParams.get("codConsulta");
					}
					
					if (urlParams.has("nombreMedico")){
						pnombreMedico = urlParams.get("nombreMedico");
					}

					if(urlParams.has("unidadNegocio")){
						punidadNegocio = urlParams.get("unidadNegocio");
					}

					if (urlParams.has("useRag")){
						puseRag = urlParams.get("useRag");
					}
				}
			}

			// DEFINIMOS EL MENSAJE DE CARGA DE SANIA
			if (pcodEspecialidad == 19) {
				setInitSentenceLoad("Cargando <strong>asistente virtual</strong> para gestionar <strong>reserva de cita...</strong>");
			} else {
				setInitSentenceLoad("Conectando con <strong>SanIA...</strong>"); //Conectando con SanIA...
				setRunAfterAwait(true);
			}

			// DEFINIMOS EL ORIGEN
			if (porigen !== null && porigen !== "") {
				setOrigen(porigen);
			} else {
				setOrigen("None")
			}

			// DEFINIMOS LA INTERFAZ + AVATAR
			if (pavatar !== "" && pavatar !== null && pavatar !== undefined) {
				setAvatar(pavatar);
				setInterfaz("voz");
			} else {
				setAvatar("0");
				setInterfaz("texto")
			}

			// DEFINIMOS EL CODPERFIL
			if (pcodPerfil !== "" && pcodPerfil !== null && pcodPerfil !== undefined) {
				setCodigoPerfil(pcodPerfil);
			} else {
				setCodigoPerfil("None");
			}

			user = {
				id: Math.random().toString(36).replace("0.", ""),
				name: "usuario"
			};

			bot = {
				id: 'botid',
				name: 'Asistente virtual'
			};

			// Definimos el idioma a partir del parametro especificado por URL
			var locale_actual = null;
			if (planguage === "en" || pavatar === "6" || pavatar === "7") {
				locale_actual = "en-US";
			} else if (planguage === "ca") {
				locale_actual = "ca-ES";
			} else if (planguage === "de") {
				locale_actual = "de-DE";
			} else if (planguage === "pt") {
				locale_actual = "pt-PT";
			} else {
				locale_actual = "es-ES";
			}
			setLocaleBot(locale_actual)

			//acceso_bot = (paramToken !== null && paramToken !== '' ? true : (panonymous !== null && panonymous !== '' ? true : false));
			acceso_bot = true;

			if (!acceso_bot) {
				window.location.href = "index.html";
			} else {

				(async () => {

					if (!directLine) {

						const token = await getDirectLineToken();
						let options = {
							token: token,
							domain: "https://europe.directline.botframework.com/v3/directline"
						}
						setDirectLine(createDirectLine(options));
					}

					// // No pasamos la geoposicion por URL
					// if (pgeoPosition == null || pgeoPosition === "") {
					// 	var resGeoPosition = await getGeoPosition();
					// 	if (resGeoPosition) {
					// 		pgeoPosition = resGeoPosition;
					// 	}
					// }

					if (pencrypt !== null && pencrypt !== "") {
						mensaje = {
							"encrypt": "" + pencrypt,
							"geoposition": "" + pgeoPosition
						};
					}
					else {

						mensaje = {
							"token": paramToken,
							"numHc": "" + pnumHc,
							"codCita": "" + pcodCita,
							"codPerfil": "" + pcodPerfil,
							"codCentro": "" + pcodCentro,
							"tipoAccion": "" + ptipoAccion,
							"ignoreCreateUser": "" + pignoreCreateUser,
							"noSuggestions": "" + pnoSuggestions,
							"idAgendaDental": "" + pidAgendaDental,
							"idCitaDental": "" + pidCitaDental,
							"includeSession": "" + pincludeSession,
							"idExpedienteVoz": "" + pidExpedienteVoz,
							"idCitaVoz": "" + pidCitaVoz,
							"centroCitaVoz": "" + pcentroCitaVoz,
							"language": "" + locale_actual.split("-")[0],
							"geoposition": "" + pgeoPosition,
							"centro_dental": "" + pcentro_dental,
							"especialidad_dental": "" + pespecialidad_dental,
							"origen": "" + porigen,
							"codPrestacion": "" + pcodPrestacion,
							"codEspecialidad": "" + pcodEspecialidad,
							"literalPrestacion": "" + pliteralPrestacion,
							"literalCentro": "" + pliteralCentro,
							"fechaInicio": "" + pfechaInicio,
							"horaInicio": "" + phoraInicio,
							"horaFin": "" + phoraFin,
							"codMedico": "" + pcodMedico,
							"codVerificacion": "" + pcodVerificacion,
							"fb": "" + pfb,
							"codEspecialidad": "" + pcodEspecialidad,
							"idPacDental": "" + pidPacDental,
							"idCliDental": "" + pidCliDental,
							"idRecallDental": "" + pidRecallDental,
							"routeIdonia": "" + prouteIdonia,
							"codServicioBravo": "" + pcodServicioBravo,
							"claveCentroDental": "" + pclaveCentroDental,
							"videoConsulta": "" + pvideoConsulta,
							"idCuestionario": "" + pidCuestionario,
							"idColectivo": "" + pidColectivo,
							"idPoliza": "" + pidPoliza,
							"idCompania": "" + pidCompania,
							"firma": "" + pfirma,
							"iniciarCuestionario": "" + piniciarCuestionario,
							"idCliente": "" + pidCliente,
							"identificacionCliente": "" + pidentificacionCliente,
							"idMediador": "" + pidMediador,
							"genCOrigen": "" + pgenCOrigen,
							"rgpd": "" + prgpd,
							"decision": "" + pdecision,
							"telefono": "" + ptelefono,
							"nombreCliente": "" + pnombreCliente,
							"tokenDental": "" + ptokenDental,
							"saniaConnectId": "" + psaniaConnectId,
							"canal": "" + pcanal,
							"tipoCita": "" + ptipoCita,
							"idTiendaOnline": "" + pidTiendaOnline,
							"tokenTiendaOnline": "" + ptokenTiendaOnline,
							"orderId": "" + porderId,
							"tipoCasoUso": "" + ptipoCasoUso,
							"telefonoCentro": "" + ptelefonoCentro,
							"du": "" + pdu,
							"fechaNacimiento": "" + pfechaNacimiento,
							"recordatorioAnticipado": "" + precordatorioAnticipado,
							"citaModificable": "" + pcitaModificable,
							"dniCliente": "" + pdniCliente,
							"dniMedico": "" + pdniMedico,
							"idChequeo": "" + pidChequeo,
							"tokenChequeo": "" + ptokenChequeo,
							"apellidosCliente": "" + papellidosCliente,
							"huecos": "" + phuecos,
							"direccion": "" + pdireccion,
							"paginas": "" + ppaginas,
							"despedida": "" + pdespedida,
							"idWebhookWhatsapp": "" + pidWebhookWhatsapp,
							"keepContext": "" + pkeepContext,
							"email_bravo": "" + pemail_bravo,
							"predict": "" + ppredict,
							"tiempoEspera": "" + ptiempoEspera,
							"saniaChat": "" + psaniaChat,
							"model": "" + pmodel,
							"codTarjeta": "" + pcodTarjeta,
							"agr": "" + pagr,
							"ciudad": "" + pciudad,
							"tokenStiga": "" + ptokenStiga,
							"apigeeToken": "" + papigeeToken,
							"codConsulta": "" + pcodConsulta,
							"nombreMedico": "" + pnombreMedico,
							"unidadNegocio": "" + punidadNegocio,
							"whatsappParams": "" + pwhatsappParams,
							"useRag": "" + puseRag,
						};
					}


					if (!cardActionMiddleware) {

						const cardActionMiddleware00 = () => next => async ({ cardAction, getSignInUrl }) => {
							const { type, value } = cardAction;

							switch (type) {

								case 'signin':
									//console.log("CARDACTIONMIDDLEWARE: SIGNIN");
									break;

								case 'openUrl':
									//console.log("CARDACTIONMIDDLEWARE: OPENURL"); 
									if (value.includes("SANIA_EVENT:")) {
										let data = value.split("[#]")[0];
										let url = value.split("[#]")[1];
										cardAction.value = url;
										let saniaEvent = data.split("SANIA_EVENT:");
										if(saniaEvent[1].includes("&data=")){
											let data = JSON.parse(saniaEvent[1].split("&data=")[1]);
											window.top.postMessage(data, '*');
										}
										else{
											window.top.postMessage(saniaEvent[1].trim(), '*');
										}
									}

									return next({ cardAction, getSignInUrl });
								//break;

								case 'postBack': {

									return next({ cardAction, getSignInUrl });
								}

								case 'imBack': {

									return next({ cardAction, getSignInUrl });
								}

								default:
									return next({ cardAction, getSignInUrl });
							}
						};

						setCardActionMiddleware(() => cardActionMiddleware00);
					}

					// COGNITIVE SERVICES SDK 					
					if (!webSpeechPonyfillFactory) {

						function getCredentialsCognitiveServicesMicrosoft() {
							return new Promise((resolve, reject) => {
								fetch(
									'https://westus.api.cognitive.microsoft.com/sts/v1.0/issueToken',
									{
										headers: {
											'Ocp-Apim-Subscription-Key': sania_credentials.COGNITIVE_SERVICES_SUBSCRIPTION_KEY
										},
										method: 'POST'
									}
								)
									.then((response) => {
										if (!response.ok) {
											reject(response);
										} else return response.text();
									})
									.then((data) => {
										var credenciales = { authorizationToken: data, region: 'westus', token: data };
										resolve(credenciales);
									})
									.catch((error) => {
										console.log("Error: " + JSON.stringify(error));
										reject(error);
									});
							});
						}

						function createFetchSpeechServicesCredentials() {
							let expireAfter = 0;
							let lastPromise;
							return () => {
								const now = Date.now();
								if (now > expireAfter) {
									expireAfter = now + 300000;
									lastPromise = new Promise((resolve, reject) => {
										getCredentialsCognitiveServicesMicrosoft().then((data, err) => {
											if (err) { expireAfter = 0; reject(err); }
											else { resolve(data); }
										});
									});
								}
								return lastPromise;
							};

						}

						async function createSpeechRecognitionOnlyPonyfillFactory() {
							const speechServicesPonyfillFactory = await window.WebChat.createCognitiveServicesSpeechServicesPonyfillFactory(
								{
									credentials: createFetchSpeechServicesCredentials()
								}
							);
							return options => {
								const speechServicesPonyfill = speechServicesPonyfillFactory(options);
								return {
									SpeechGrammarList: speechServicesPonyfill.SpeechGrammarList,
									SpeechRecognition: speechServicesPonyfill.SpeechRecognition
								};
							};
						}

						const wspfactory = await createSpeechRecognitionOnlyPonyfillFactory();
						setWebSpeechPonyfillFactory(() => wspfactory);
					}

					// DEFINIMOS TIEMPO DE ESPERA ANTES DE ARRANCAR SANIA PARA VISUALIZAR LA PAGINA DE CARGA
					if (!runAfterAwait) {
						let timeToWait = 5000; // ms
						setTimeout(() => {
							setRunAfterAwait(true);
						}, timeToWait);
					}

				})();
			}
		},
		[count]
	);


	useEffect(() => {
		if (myRef.current) {

			const node = ReactDOM.findDOMNode(myRef.current);

			// Get child nodes
			if (node instanceof HTMLElement) {

				//SENDBOX ............................................................................

				var child = node.querySelector('input[data-id="webchat-sendbox-input"]');

				var sendButton = node.querySelector('button[data-id="webchat-sendbox-send-button"]');
				if (!botonTieneListener) {
					sendButton.style.visibility = 'hidden';
					sendButton.addEventListener("click", () => {
						if (child.value) {
							store.dispatch({
								type: 'WEB_CHAT/SUBMIT_SEND_BOX',
								payload: { method: 'keyboard' }
							});
						}
					});

					botonTieneListener = true;
				}

				if (child) {
					//TENGO QUE VER SI YA EXISTE  O NO EL EVENT LISTENER
					try {
						if (!textTieneListener) {
							//console.log("NO EXISTE ONKEYUP");
							child.addEventListener("keyup", handleTextboxKeyup);
							textTieneListener = true;
						}
					}
					catch (error) {
						console.log("ERROR AL LLAMAR A addEventListener:" + error);
					}
				}
			}
		}
	});

	// Cambios de valores por defecto (StyleSetOptions)  
	const styleSet = createStyleSet({
		primaryFont: 'Montserrat, sans-serif',
		backgroundColor: '#fbfbfb', //'Transparent'
		paddingRegular: 10,
		paddingWide: 20,
		sendBoxBackground: 'white',
		hideScrollToEndButton: false,
		sendBoxHeight: 68,

		bubbleBackground: '#FFFFFF', //#0079c8, ECF6FF Cambiado para dar aspecto grisaceo al mensaje del bot
		bubbleBorderColor: '#FFFFFF', //#0079c8, ECF6FF
		bubbleBorderRadius: '0px 12px 12px 12px',
		bubbleBorderStyle: 'solid',
		bubbleBorderWidth: 1,

		bubbleFromUserBackground: '#0079c8', //EBF5F5 Cambiado para dar aspecto corporativo al mensaje del user
		bubbleFromUserBorderColor: '#0079c8', //EBF5F5
		bubbleFromUserTextColor: 'white',
		bubbleFromUserBorderRadius: '12px 12px 0 12px',
		bubbleFromUserBorderStyle: 'solid',
		bubbleFromUserBorderWidth: 1,

		bubbleMaxWidth: 480, //'100%', // screen width = 600px
		bubbleMinHeight: 30, //Por defecto 40
		bubbleMinWidth: 250,
		bubbleImageHeight: 50, //Por defecto 240

		sendBoxButtonColor: '#0078d7',
		sendBoxButtonColorOnDisabled: '#0078d7',
		sendBoxButtonColorOnFocus: '#0078d7',
		sendBoxButtonColorOnHover: '#0078d7',

		// Suggested actions
		suggestedActionBackground: 'White',
		suggestedActionBorderColor: '#fff',
		suggestedActionBorderStyle: 'solid',
		suggestedActionBorderWidth: '1px',
		suggestedActionBorderRadius: '8px',
		suggestedActionTextColor: '#0079c8',
		suggestedActionHeight: 40,//32
		suggestedActionLayout: 'carousel', // either "carousel" or "stacked"

		// Transcript overlay buttons (e.g. carousel and suggested action flippers, scroll to bottom, etc.)
		transcriptOverlayButtonBackground: 'rgba(0, 0, 0, .6)',
		transcriptOverlayButtonBackgroundOnFocus: 'rgba(0, 0, 0, .8)',
		transcriptOverlayButtonBackgroundOnHover: 'rgba(0, 0, 0, .8)',
		transcriptOverlayButtonColor: 'White',
		transcriptOverlayButtonColorOnFocus: undefined, // defaults to transcriptOverlayButtonColor
		transcriptOverlayButtonColorOnHover: undefined, // defaults to transcriptOverlayButtonColor

		typingAnimationBackgroundImage: 'url(data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ibGRzLXR5cGluZyIgd2lkdGg9IjcwcHgiIGhlaWdodD0iNTBweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiBzdHlsZT0iYmFja2dyb3VuZDogbm9uZTsiPjxjaXJjbGUgY3g9IjI0LjUiIGN5PSI0OC40MjYzIiByPSI2IiBmaWxsPSIjMjI1NTZFIj4gIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN5IiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswLjUgMCAxIDAuNTswLjUgMC41IDAuNSAwLjUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjYyLjU7MzcuNTs2Mi41OzYyLjUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzEiIGR1cj0iMXMiIGJlZ2luPSItMC41cyIvPjwvY2lyY2xlPiA8Y2lyY2xlIGN4PSI0MS41IiBjeT0iNjIuNSIgcj0iNiIgZmlsbD0iIzQ3OTlCNyI+ICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJjeSIgY2FsY01vZGU9InNwbGluZSIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MC41IDAgMSAwLjU7MC41IDAuNSAwLjUgMC41IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSI2Mi41OzM3LjU7NjIuNTs2Mi41IiBrZXlUaW1lcz0iMDswLjI1OzAuNTsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMzc1cyIvPjwvY2lyY2xlPiA8Y2lyY2xlIGN4PSI1OC41IiBjeT0iNjIuNSIgcj0iNiIgZmlsbD0iIzZEQjNCRiI+ICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJjeSIgY2FsY01vZGU9InNwbGluZSIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MC41IDAgMSAwLjU7MC41IDAuNSAwLjUgMC41IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSI2Mi41OzM3LjU7NjIuNTs2Mi41IiBrZXlUaW1lcz0iMDswLjI1OzAuNTsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMjVzIi8+PC9jaXJjbGU+IDxjaXJjbGUgY3g9Ijc1LjUiIGN5PSI2Mi41IiByPSI2IiBmaWxsPSIjOTRDRkM5Ij4gIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN5IiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswLjUgMCAxIDAuNTswLjUgMC41IDAuNSAwLjUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjYyLjU7MzcuNTs2Mi41OzYyLjUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzEiIGR1cj0iMXMiIGJlZ2luPSItMC4xMjVzIi8+PC9jaXJjbGU+PC9zdmc+)',
		typingAnimationDuration: 60000, //milliseconds - por defecto 5000
		typingAnimationHeight: 40,
		typingAnimationWidth: 60,

		//Se quitan los div de tiempo asociados a cada bubble
		groupTimestamp: false,
	});

	const adaptiveCardsHostConfig = {
		"supportsInteractivity": true,
		"spacing": {
			"small": 4,
			"default": 8,
			"medium": 16,
			"large": 24,
			"extraLarge": 32,
			"padding": 8
		},
		"separator": {
			"lineThickness": 1,
			"lineColor": "#cccccc"
		},
		"fontFamily": "Montserrat, sans-serif",
		"fontSizes": {
			"small": 12,
			"default": 13,
			"medium": 15,
			"large": 17,
			"extraLarge": 19
		},
		"fontWeights": {
			"lighter": 200,
			"default": 400,
			"bolder": 700
		},
		"containerStyles": {
			"default": {
				"backgroundColor": "#00000000",
				"foregroundColors": {
					"default": {
						"default": "#000000",
						"subtle": "#808c95"
					},
					"accent": {
						"default": "#2e89fc",
						"subtle": "#802E8901"
					},
					"attention": {
						"default": "#ffd800",
						"subtle": "#CCFFD800"
					},
					"good": {
						"default": "#00ff00",
						"subtle": "#CC00FF00"
					},
					"warning": {
						"default": "#ff0000",
						"subtle": "#CCFF0000"
					}
				}
			},
			"emphasis": {
				"backgroundColor": "#08000000",
				"foregroundColors": {
					"default": {
						"default": "#333333",
						"subtle": "#EE333333"
					},
					"accent": {
						"default": "#2e89fc",
						"subtle": "#882E89FC"
					},
					"attention": {
						"default": "#cc3300",
						"subtle": "#DDCC3300"
					},
					"good": {
						"default": "#54a254",
						"subtle": "#DD54A254"
					},
					"warning": {
						"default": "#e69500",
						"subtle": "#DDE69500"
					}
				}
			}
		},
		"imageSizes": {
			"small": 40,
			"medium": 80,
			"large": 160
		},
		"actions": {
			"maxActions": 100,
			"spacing": "default",
			"buttonSpacing": 8,
			"showCard": {
				"actionMode": "inline",
				"inlineTopMargin": 8
			},
			"actionsOrientation": "vertical",
			"actionAlignment": "stretch"
		},
		"adaptiveCard": {
			"allowCustomStyle": false
		},
		"imageSet": {
			"imageSize": "medium",
			"maxImageHeight": 100
		},
		"factSet": {
			"title": {
				"color": "default",
				"size": "default",
				"isSubtle": false,
				"weight": "bolder",
				"wrap": true,
				"maxWidth": 150
			},
			"value": {
				"color": "default",
				"size": "default",
				"isSubtle": false,
				"weight": "default",
				"wrap": true
			},
			"spacing": 8
		}
	};

	//Analizador de StyleSets
	/* styleSet.CarouselFlipper = {
		...styleSet.CarouselFlipper,
		'&': {
			backgroundColor: 'black'
		}
	}; */

	//Personalizaciones  

	styleSet.uploadButton = {
		...styleSet.uploadButton,
		display:
		  "none",
	};

	styleSet.bubble = {
		...styleSet.bubble,
		'&': {
			overflow: 'visible',
			'& > div.webchat__bubble__content': {
				overflow: 'visible',
				//boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)', Primer metodo para poner el box shadow, se comenta para intentar no atacar a las adaptative-card
				'& > div.markdown': {
					boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)',
					borderRadius: '0px 12px 12px 12px',
				}
			}
		},
		'& > div.webchat__bubble__content > div.markdown': {
			padding: '14px'
		},

		'& > div.webchat__bubble__content > div.markdown > p': {
			fontSize: '14px'
		},
		'&.from-user > div.webchat__bubble__content': {
			padding: '14px',
			minHeight: 'auto',
			boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)'
		},
		'&.from-user > div.webchat__bubble__content > p': {
			fontSize: '14px',
			padding: '0'
		},

		/* Div de link de descarga de chequeo PDF */

		'& > div.webchat__bubble__content > div.webchat__fileContent': {
			padding: '0px',

			'& > .webchat__fileContent__buttonLink': {
				background: '#0079c8',
				borderRadius: '12px',
				marginTop: '10px',
				maxWidth: '200px',
				boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)',

				'& > .webchat__fileContent__badge > .webchat__fileContent__fileName': {
					color: 'White',
					marginLeft: '10px'
				},
				'& > .webchat__fileContent__downloadIcon': {
					fill: 'white',
					padding: '5px 10px'
				}
			}
		}
	};
	//---------------------------------------------------------------------
	styleSet.sendBox = {
		...styleSet.sendBox,
		'& > .main': {
			alignItems: 'stretch',
			boxShadow: '0 0 12px rgba(0, 0, 0, 0.2)',
			backgroundColor: '#FFFFFF',
			borderBottom: '0px',
			borderLeft: '0px',
			borderRight: '0px',
			borderTop: '0px',
			minHeight: '72px',
			fontSize: '1.25em',
			color: 'White',
			width: '100%',
			bottom: '0',
			position: 'relative',
			zIndex: '99',
			'& > .status': {
				opacity: '0.7',
				color: '#0079c8',
			},
			'& > .dictating': {
				opacity: '0.7',
				color: '#0079c8',
			},
		}
	};
	//---------------------------------------------------------------------
	styleSet.sendBoxTextBox = {
		...styleSet.sendBoxTextBox,
		backgroundColor: '#ffffff',
		borderRadius: '48px',
		margin: '12px 0px 12px 12px',
		border: '1px solid #D9D9D9 !important',
		bottom: '0',
		boxSizing: 'border-box',
		height: '48px',
		left: '0',
		right: '0',
		'& > input': {
			bottom: '0',
			width: '100%',
			margin: '0 16px',
			fontSize: '14px !important',
			border: 'none',
		},
		'& > input:focus': {
			outline: 'none'
		},
	};
	//---------------------------------------------------------------------
	styleSet.sendBoxButton = {
		...styleSet.sendBoxButton,
		backgroundColor: '#0079c8 !important',
		borderRadius: '44px !important',
		width: '44px !important',
		height: '44px !important',
		margin: '14px 12px 14px 8px',
		'& > svg': {
			fill: '#FFFFFF !important',
		}
	};
	//---------------------------------------------------------------------
	styleSet.sendStatus = {
		...styleSet.sendStatus,
		display: 'none'
	};
	//---------------------------------------------------------------------
	/* SUGGESTED ACTION */
	styleSet.suggestedAction = {
		...styleSet.suggestedAction,
		paddingBottom: '5px',
		paddingRight: '2px',
		paddingTop: '5px',
		'& > button': {
			fontFamily: 'Montserrat, sans-serif',
			fontSize: '14px !important',
			height: '40px !important',
			padding: '0 10px !important',
			borderRadius: '8px !important',
			cursor: 'pointer',
			transition: 'color .2s ease, background-color .2s ease',
			boxShadow: '0 0 14px rgba(0,0,0,.1)',
			minHeight: '32px',
			minWidth: '32px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			fontWeight: '600',
			lineHeight: 'normal', //'1em' //Cambiado de 3rem a normal para que el Display alinee correctamente
			letterSpacing: '0',
			whiteSpace: 'nowrap',
			margin: '2px 0',
			width: '100%',
			display: 'flex', //Alineación y justificación de margenes en suggestedAction
			alignItems: 'center', //Alineación y justificación de margenes en suggestedAction
			justifyContent: 'center', //Alineación y justificación de margenes en suggestedAction

			'&:disabled': {
				background: 'White',
				border: 'solid 2px #E6E6E6',
				color: '#767676'
			},

			'&:not(:disabled)': {
				background: 'White',
				border: '1px solid #fff',
				color: '#0079c8',
				'&:hover': {
					backgroundColor: '#fff',
					border: '1px solid #0078d7 !important',
					color: '#0078d7'
				},
				'&:active': {
					backgroundColor: '#d4eaf9 !important',
				}
			}
		}
	};
	//---------------------------------------------------------------------
	styleSet.suggestedActions = {
		...styleSet.suggestedActions,
		paddingLeft: '0px',
		paddingRight: '6px',
		backgroundColor: '#e9f3fa !important', //'#F4F9FD' Se actualiza el color al azul que contrasta mas con el gris de fondo nuevo
		height: '50px', //44px
		display: 'flex',
		alignItems: 'center',

		'& button > div.slider': {
			left: '0px !important',
			zIndex: '9999'
		},

		//NUEVO

		'&  button > div.slider > div': {
			backgroundColor: 'rgba(0, 0, 0, .6)',
			color: 'White',
			outline: 0,
			fontSize: '20px',
			fontWeight: '600',
			border: '2px solid !important',
			borderColor: '#0078d7 !important'
		},

		'&:disabled button > div.slider > div': {
			backgroundColor: 'rgba(0, 0, 0, .3)',
			color: 'White'
		},

		'&:focus button > div.slider > div': {
			backgroundColor: 'rgba(0, 0, 0, .8)',
			color: 'White'
		},

		'&:hover button > div.slider > div': {
			backgroundColor: 'rgba(0, 0, 0, .8)',
			color: 'White'
		}

	};
	//---------------------------------------------------------------------

	/* ADAPTIVE CARDS */
	styleSet.adaptiveCardRenderer = {
		...styleSet.adaptiveCardRenderer,

		/* Principio ActionSet */

		'& .ac-actionSet': {
			padding: '14px',
			backgroundColor: '#e9f3fa',
			borderRadius: '12px',
		},
		'& .ac-pushButton': {
			backgroundColor: '#ffffff',
			color: '#0078d7',
			border: 'none !important',
			boxShadow: '0 0 14px rgba(0,0,0,0.14)',
			borderRadius: '12px', //'10px'
			minHeight: '46px',
			padding: '0 16px !important', //Lo metemos como important porque algo nos está pisando el style en html puro
			letterSpacing: '0',
			fontWeight: '600',
			cursor: 'pointer',
			transition: 'color .2s ease, background-color .2s ease',
			'& > div': {
				fontSize: '14px',
				whiteSpace: "unset !important" // Quitar los ... en botones en iphone 
			},
			'&:hover': {
				border: '1px solid #0078d7 !important'
			},
			'&:focus': {

			},
		},

		/* Final ActionSet */

		'& .ac-image': {
			borderRadius: '12px !important',
		},

		'& .ac-textBlock': {
			paddingTop: '8px',
			whiteSpace: 'normal !important',
			color: '#0079c8 !important',
			fontSize: '14px !important'
		},
		'& .ac-input-container > input': {
			fontSize: '13px !important',
			marginTop: '5px'
		},

		/* Principio ac-selectable Acciones/Medicos */

		'& .ac-selectable': {

			/* Prueba para poner el fondo en el azul de interacción */
			padding: '4px 12px !important',
			backgroundColor: '#e9f3fa !important',
			borderRadius: '0 !important',
			'& .ac-columnSet': {
				padding: '12px !important',
				backgroundColor: 'white',
				borderRadius: '12px',
				border: '1px solid transparent',
				boxShadow: '0 0 14px rgba(0,0,0,0.14)',
				'&:hover': {
					border: '1px solid #0078d7',
				},
				'&:active': {
					backgroundColor: '#d4eaf9',
				},
				'& .ac-image': {
					borderRadius: '0 !important',
					height: '35px !important',
					width: 'auto !important',
				}
			},
			/* Prueba para poner el fondo en el azul de interacción */

			'& .ac-textBlock': {

				paddingTop: '4px',

				'& > p': {
					fontSize: '14px',
					fontWeight: '600'
				},
			},

			'& .ac-columnSet > .ac-container': {
				justifyContent: 'center !important'
			},
			'& .ac-columnSet > .ac-vertical-separator': {
				width: '15px !important',
				borderRight: 'none !important'
			},
		},

		'& .ac-selectable:hover': {
			cursor: 'pointer !important'
		},

		// '& .ac-selectable:active': {
		// 	backgroundColor: '#0079c8 !important',
		// },

		// '& .ac-selectable:active .ac-textBlock': {
		// 	color: 'white !important'
		// },

		/* Final ac-selectable Acciones/Medicos */

		/* Principio Adaptive Card general */

		'& .ac-adaptiveCard': {
			borderRadius: '12px', //'10px'
			backgroundColor: 'transparent',
			maxWidth: '380px',

			'& > .ac-horizontal-separator': {
				height: '8px !important'
			}
		},

		'& .ac-input-container > .ac-input.ac-choiceSetInput-multiSelect > div': {
			paddingTop: '15px'
		},

		/* Final Adaptive Card general */

		/* Principio cita confirmada/Volumen Mindfullness */

		// '& .ac-container.ac-adaptiveCard > div.ac-container': {
		// 	backgroundColor: 'white',
		// 	borderRadius: '12px',
		// 	padding: '14px !important',
		// 	boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)'
		// }, Todavía no podemos usar esto porque pisa a otras cosas que no nos interesan

		/* Final cita confirmada/Volumen Mindfullness */
	}
	//---------------------------------------------------------------------
	styleSet.carouselFilmStrip = {
		...styleSet.carouselFilmStrip,
		// Browser quirks: Firefox has no way to hide scrollbar and while keeping it in function
		// https://developer.mozilla.org/en-US/docs/Web/CSS/overflow

		'@supports (-moz-appearance: none)': {
			marginBottom: -17
		},

		'& > .avatar': {
			marginLeft: '10',
			marginRight: '10',
		},

		'& > .content': {

			marginBottom: '10px', //Margen inferior en carousel para que se vea la sombra sin alterar los overflow
			marginTop: '10px', //Margen superior para mantener las distancias similares

			'& > .message': {
				marginLeft: '10'
			},

			'& > ul': {
				marginRight: '10',
				backgroundColor: '#e9f3fa', //Lo comentamos para que las tarjetas de especialidades y centros parezcan individuales
				padding: '0px',
				borderRadius: '12px',

				'&:not(:first-child)': {
					marginTop: '10'
				},

				'& > li': {
					maxWidth: '380', //Estaba comentado
					minWidth: '320px', //338px //250
					padding: '0', //'0'
					'&:not(:last-child)': {
						marginRight: '0 !important', //'10px'
						border: 'none'
					},
				},

				'& > li > div': {
					background: 'transparent !important', //'#efefef !important',
					border: 'none !important',
					color: 'Black !important',

					'& > .webchat__bubble__content': {
						background: 'transparent',
						border: '0 !important',
						/*Puesto para que quite el borde azul en el carousel de centros */

						'& > div > .ac-container.ac-adaptiveCard:not(.ac-selectable)': {
							border: '0 !important',
							padding: '0 !important', //Se pone padding 0 para que solo afecte a las adaptive del carousel
							/* Puesto para quitar el borde azul cuando clicas en alguna parte del carousel de centros */
							'&:focus': {
								outline: 'none',
							}
						},

						/*Puesto para que quite el fondo blanco en el carousel de centros */
						'& > div > .ac-container.ac-adaptiveCard:not(.ac-selectable) > .ac-container': {
							backgroundColor: 'transparent !important',
							borderRadius: '12px !important',
							border: '2px solid transparent',
							padding: '12px !important', //'10px !important'
							boxShadow: 'none !important',

							'& > .ac-textBlock > p': {
								minHeight: '38px'
							}
						},
					},
				}
			},

			'& > .row': {
				marginLeft: '10'
			}
		}
	}
	//---------------------------------------------------------------------
	//Para que los botones de siguiente y anterior esten siempre visibles
	styleSet.carouselFlipper = {
		...styleSet.carouselFlipper,

		'& > div.slider': {
			left: '0px !important'
		},

		'&.hide': {
			display: 'none'
		},

		'& > div.slider > div.button': {
			backgroundColor: 'rgba(0,51,91,0.9) !important',
			color: 'White',
			fontSize: '26px',
			fontFamily: 'Poppins, sans-serif',
			fontWeight: '600',
			border: 'none',
			boxShadow: '0 0 14px rgba(0,0,0,0.4) !important',
			cursor: 'pointer'
		},
	}

	//---------------------------------------------------------------------
	styleSet.stackedLayout = {
		...styleSet.stackedLayout,

		transform: 'translate3d(0,0,0)', //Para evitar el problema en IOS (Safari y Chrome) de las areas blancas que cortan los mensajes 
		zIndex: '9899',

		'&.webchat__stacked_extra_left_indent': {
			marginLeft: 10 * 2
		},

		'&:not(.webchat__stacked_extra_left_indent)': {
			marginLeft: 10
		},

		'&.webchat__stacked_extra_right_indent': {
			marginRight: 10 * 2
		},

		'&:not(.webchat__stacked_extra_right_indent)': {
			marginRight: 10
		},

		'&:not(.from-user)': {
			'&.webchat__stacked_indented_content > .avatar': {
				marginRight: 10
			},

			'& > .content > .webchat__stacked_item_indented': {
				marginLeft: 10
			}
		},

		'&.from-user': {
			'&.webchat__stacked_indented_content > .avatar': {
				marginLeft: 10
			},

			'& > .content > .webchat__stacked_item_indented': {
				marginRight: 10
			}
		},

		'& > .webchat__stackedLayout__content': {
			overflow: 'visible',
			'& > .webchat__row': {
				'& > .bubble': {
					overflow: 'visible'
				},
				'& > .bubble, & > .timestamp': {
					maxWidth: 480
				},
				'&.attachment > .bubble': {
					minWidth: 250,
					borderRadius: '12px' //20px	
				},
				'&.attachment': {
					'& > div.attachment': {
						'& > div.webchat__bubble__content': {
							background: 'transparent',
							border: '0 !important',
							//Icono desgargar pdf
							'& > div > img[alt="pdf.png"]': {
								width: '40px !important',
								height: '40px !important',
								left: '5%'
							},
							//Enlace descarga pdf
							'& > div > a': {
								padding: '2px !important'
							}
						}
					}
				}
			},

			'& > .attachment:not(:first-child):not(:last-child)': {
				marginTop: 0, //Por defecto 10
			},
			'& > .attachment.webchat__row:first-child > .bubble > .webchat__bubble__content > .webchat__adaptive-card-renderer > .ac-selectable': {
				padding: '12px 12px 4px 12px !important',
				borderRadius: '12px 12px 0px 0px !important'
			},
			'& > .attachment.webchat__row:nth-last-child(2) > .bubble > .webchat__bubble__content > .webchat__adaptive-card-renderer > .ac-selectable': {
				padding: '4px 12px 12px 12px !important',
				borderRadius: '0px 0px 12px 12px !important'
			}
		}
	}
	//---------------------------------------------------------------------
	//DEJAMOS EL BOT�N DE NUEVOS MENSAJES OCULTO
	styleSet.scrollToEndButton = {
		...styleSet.scrollToEndButton,

		// TODO: [P3] Can we not to unset borderWidth and outline earlier?
		'@media screen and (-ms-high-contrast: active)': {
			borderWidth: 'initial',
			outline: 'initial'
		},

		visibility: 'hidden',
		backgroundColor: 'rgba(0, 0, 0, .6)',
		borderRadius: 10,
		borderWidth: 0,
		bottom: 5,
		color: 'White',
		outline: 0,
		padding: 10,
		position: 'absolute',
		right: 20,

		'&:hover': {
			visibility: 'hidden',
			backgroundColor: 'rgba(0, 0, 0, .8)',
			color: 'White'
		},

		'&:focus': {
			visibility: 'hidden',
			backgroundColor: 'rgba(0, 0, 0, .8)',
			color: 'White'
		}
	}

	//---------------------------------------------------------------------
	styleSet.typingIndicator = {
		...styleSet.typingIndicator,
		paddingBottom: 10,
		paddingLeft: 10,
		//backgroundImage: 'linear-gradient(0deg, rgb(255,255,255) 20%, rgb(236,246,255) , rgb(223,233,242))',
		// boxShadow: '0 -3px 15px rgba(110, 110, 110, 0.1)'
		'& > .webchat__typingIndicator': {
			backgroundColor: '#FFFFFF',
			padding: '4px 12px 4px 2px',
			borderRadius: '0px 12px 12px 12px',
			boxShadow: '2px 2px 5px 1px rgba(0,0,0,.1)'
		}
	}
	//---------------------------------------------------------------------
	const activityMiddleware = () => next => card => {
		scrollToEndCustom();
		if (card.activity.from.role !== 'user' && card.activity.type === 'message') {

			if (JSON.stringify(card.activity).indexOf("LISIS CL") >= 0) {
				return children => (
					<div data-chequeo="true">
						{next(card)(children)}
					</div>
				);
			}
			else { return next(card); }
		} else { return next(card); }
	};

	if (directLine && cardActionMiddleware && webSpeechPonyfillFactory && origen && avatar && localeBot && runAfterAwait && codigoPerfil) {

		// Default variables
		let logoImage = "./img/sanitas_new_logo.svg"; // "./img/sanitas-whitebg.svg"
		let widthLogoImage = "120px"; //Previamente 30px
		let heightLogoImage = "auto"; // Previamente 30px
		let styleHeaderSpan = { left: "0px" };
		let styleHeader = { backgroundColor: "#FFFFFF" };
		let nameHeader = "";
		let wcPanelTextVisibility = "";
		let wcPanelVoiceVisibility = "";
		let styleSpeaker = { marginTop: "6px", zIndex: "9999" };
		let styleCallIcon = { marginTop: "6px", zIndex: "9999", visibility: "hidden" };
		let textPanicButtonBrabu = "";

		// Cambio estilo frontal para que aparezca boton te llamamos (Brabu)
		if (codigoPerfil.toLocaleLowerCase() == "brabu") {
			
			textPanicButtonBrabu = "¿Te llamamos?";
			if (localeBot.split("-")[0] === "en"){
				textPanicButtonBrabu = "Should we call you?";
				styleCallIcon.width = "164px";
			}
			else if (localeBot.split("-")[0] === "ca"){
				textPanicButtonBrabu = "Et truquem?";
			}
			else if (localeBot.split("-")[0] === "de"){
				textPanicButtonBrabu = "Sollen wir Sie anrufen?";
			}
			else if (localeBot.split("-")[0] === "fr"){
				textPanicButtonBrabu = "Devons-nous vous appeler?";
			}
			styleCallIcon.visibility = "visible";
			if (origen.toLocaleLowerCase().includes("sabadell")){
				logoImage = "./img/sanitas_sabadell.png";
				widthLogoImage = "148px";
			}
		}

		// Cambio estilo frontal para que no aparezca el logo de Sanitas
		if (codigoPerfil.toLocaleLowerCase() == "hem") {
			logoImage = "./img/sania.png";
			widthLogoImage = "30px"; //Previamente 30px
			heightLogoImage = "30px"; // Previamente 30px
			nameHeader = "SanIA";
		}

		// Cambio estilo iberdic
		if (origen.toLocaleLowerCase() == "ibermedic") {
			logoImage = "./img/ibermedic.png";
			widthLogoImage = "120px"; 
			nameHeader = "SanIA";
		}

		// Cambio estilo frontal segun centro utilizando el parametro origen
		if (origen.toLocaleLowerCase() == "manises") { // Manises
			styleSet.sendBox['& > .main'].backgroundColor = "#0079C8";
			logoImage = "./img/manises.png";
			styleHeader = { backgroundColor: "#0079C8" };
			nameHeader = "";
			widthLogoImage = "385px";
			heightLogoImage = "58px";
			styleHeaderSpan = { top: "0px", left: "0px" };
		}

		// Definicion de idioma en el frontal inicial
		let escuchando = "Escuchando...";
		if (localeBot.split("-")[0] === "en") {
			escuchando = "Listening...";
		}

		let Header = null;
		let videoInicial = <video autoPlay muted playsInline preload="auto" id="silence1" src={"./videos/" + avatar + "/silence1.mp4"} style={{ display: "block", margin: "auto", borderRadius: "125px" }}></video>;
		if (interfaz == "texto") {
			Header = ({ children }) => (
				<div className="wc-wrapper">
					<div className="wc-header" style={styleHeader}>
						<span className="wc-header-span" style={styleHeaderSpan}>
							{/* <svg width="85" height="31" viewBox="0 0 85 32" fill="none" xmlns="http://www.w3.org/2000/svg">
							<mask id="path-1-outside-1" maskUnits="userSpaceOnUse" x="0" y="0" width="85" height="31" fill="black">
							<rect fill="white" width="85" height="31"/>
							<path d="M70.6497 1C71.3797 1 71.9011 2.03788 72.0054 3.72574C72.1261 5.48756 72.2669 9.16383 72.3864 12.8363L72.4147 13.7166C72.5398 17.6689 72.6363 21.4378 72.6519 22.6067C72.6519 22.6591 72.6519 22.8373 72.7875 22.8373C72.8605 22.8373 72.9022 22.7849 72.9439 22.7325C73.4966 21.8938 74.8836 19.8495 75.7491 18.9584C76.3852 18.2979 76.9066 17.9939 77.4593 17.9939C77.8556 17.9939 78.2832 18.1512 78.7837 18.4866C79.2008 18.7697 79.5867 19.0737 79.9621 19.3568C80.7025 19.9334 81.4116 20.4785 82.2042 20.7511C82.8716 20.9817 84.0082 21.0342 84.8425 21.0342C85.3013 21.0342 85.8123 21.0132 86 21.0027L85.6454 22.9422C85.489 22.9527 84.9572 22.9631 84.4566 22.9631C83.6745 22.9631 82.5691 22.9212 81.714 22.6801C80.4105 22.3236 79.2634 21.6317 78.5751 21.1285L78.231 20.8874C77.5845 20.4366 77.1256 20.4366 76.7294 20.8664C76.4687 21.1495 75.5718 22.4914 74.7793 23.6865L73.9138 24.9655C73.4445 25.6574 72.7771 26.1082 72.2244 26.1082C71.7447 26.1082 71.3589 25.7937 71.1086 25.1752C70.818 24.478 70.5901 19.8912 70.4356 15.0605L70.4118 14.2963C70.4002 13.9137 70.3891 13.5308 70.3784 13.1494L70.3577 12.389C70.3076 10.4955 70.2691 8.66875 70.243 7.1329V7.11194C70.243 6.96517 70.1596 6.90227 70.0762 6.90227C70.0032 6.90227 69.9302 6.97565 69.8989 7.08049L69.8051 7.48935C68.4077 13.5594 65.0811 28.0582 64.5284 29.8194C64.1113 31.1508 63.3813 32 62.6618 32C62.1925 32 61.7858 31.6121 61.5042 30.9097C60.9098 29.4001 60.4406 27.1356 60.1381 25.6889L59.8983 24.6091C59.7627 24.0534 59.5959 23.6865 59.2413 23.6865C58.9806 23.6865 58.6469 23.8857 58.1776 24.2212C57.2391 24.8921 55.6853 25.8671 54.0064 25.8671H37.5612L37.9366 23.7809H53.5684C55.1639 23.7809 56.1337 22.9527 56.9784 22.2083C57.2808 21.9462 57.5624 21.7051 57.8544 21.5059C59.1788 20.6253 60.2737 20.6987 61.0141 21.747C61.6607 22.6696 61.9944 24.347 62.3802 26.2969C62.4949 26.905 62.62 27.6388 62.7556 28.2888C62.7973 28.4565 62.9955 28.4565 63.0267 28.2888C64.299 21.9777 67.2606 9.55462 68.6475 3.96686C69.2002 1.77579 70.0658 1 70.6497 1ZM38.0721 5.59182C38.8751 5.59182 39.4904 6.18938 39.3444 6.97565L39.0941 8.349C39.287 8.34376 39.8423 8.34114 40.3494 8.33983L40.6758 8.33913C40.7275 8.33905 40.7775 8.33897 40.8252 8.33891L41.3153 8.33852L41.0546 9.76429H38.8334L37.9679 14.6077C37.6759 16.2327 39.4278 15.8972 40.1369 15.6875C40.1369 15.6875 39.9388 16.7778 39.8345 17.2915C39.5008 17.4068 38.8021 17.4802 38.312 17.4802C36.8103 17.4802 35.5381 16.673 35.9552 14.5867L36.8103 9.76429H35.5381L35.7988 8.33852H37.071L37.5612 5.59182H38.0721ZM7.00662 4.63781C8.96712 4.63781 9.87437 5.17247 10.2498 5.43456C10.1455 5.73859 9.4781 6.92323 9.4051 7.08049C9.06097 6.84985 8.38314 6.25228 6.8502 6.25228C5.20255 6.25228 4.79585 7.44741 4.79585 7.90869C4.79585 10.299 9.34254 9.79574 9.34254 13.4964C9.34254 15.8028 7.22562 17.4697 4.66029 17.4697C3.12735 17.4697 1.90725 17.0085 1 16.3899C1.2607 15.8972 1.77168 14.9642 1.88639 14.7335C2.68936 15.4359 3.69047 15.7609 4.629 15.7609C5.83867 15.7609 7.24647 15.3101 7.24647 13.79C7.24647 11.4941 2.66851 11.9868 2.66851 8.26513C2.66851 6.69259 4.13888 4.63781 7.00662 4.63781ZM15.4534 8.13933C17.049 8.13933 18.0396 8.9885 18.3838 9.6909L18.6445 8.32804H20.5737L19.0199 17.2705H18.4568C17.7998 17.2705 17.1115 16.7568 17.2784 15.9286L17.3097 15.7924C16.7465 16.6835 15.808 17.4592 14.0665 17.4592C12.2103 17.4592 10.3749 15.7924 10.6982 12.9513C10.9798 10.4772 12.6483 8.13933 15.4534 8.13933ZM45.862 8.13933C47.4575 8.13933 48.4377 8.9885 48.7923 9.6909L49.053 8.32804H50.9822L49.418 17.2705H48.8549C48.2083 17.2705 47.5201 16.7568 47.6869 15.9286L47.7182 15.7924C47.1551 16.6835 46.2165 17.4592 44.4646 17.4592C42.6084 17.4592 40.7835 15.7924 41.1067 12.9618C41.3883 10.4772 43.0568 8.13933 45.862 8.13933ZM55.7375 8.04498C57.2183 8.04498 58.0629 8.51674 58.2506 8.66351L57.5311 10.0264C57.1035 9.82719 56.749 9.46026 55.5498 9.46026C54.7468 9.46026 54.0585 9.98444 54.0585 10.5715C54.0585 12.0602 57.6458 11.7771 57.6458 14.419C57.6458 15.9811 55.9982 17.3754 53.8708 17.3754C52.2023 17.3754 51.2429 16.7464 50.8466 16.4738C51.0135 16.2012 51.4932 15.3206 51.587 15.1529C52.1085 15.4988 52.8489 15.9286 53.7561 15.9286C54.8198 15.9286 55.6123 15.4045 55.6123 14.6287C55.6123 13.0666 52.0772 13.465 52.0772 10.8965C52.0772 9.65945 53.2556 8.04498 55.7062 8.04498H55.7375ZM33.1709 8.31755C33.9739 8.31755 34.5787 8.91512 34.4431 9.70139L33.077 17.281H31.054L32.6599 8.31755H33.1709ZM27.5918 8.13933C29.3021 8.13933 30.397 9.52317 30.0216 11.6618L29.0101 17.281H26.987L27.9777 11.7562C28.2905 10.0788 27.2581 9.74332 26.768 9.74332C25.7669 9.74332 24.3278 10.2885 23.8898 12.6368L23.0556 17.281H21.0325L22.6384 8.32804H23.1494C23.7021 8.32804 24.5259 8.76835 24.3487 9.74332C25.0474 8.7998 25.9129 8.13933 27.5918 8.13933ZM15.735 9.59655C12.5753 9.41833 11.6472 15.6666 14.6296 15.8343C17.9249 16.0125 18.9782 9.78526 15.735 9.59655ZM46.1435 9.59655C42.9734 9.42881 42.0557 15.6666 45.0277 15.8343C48.3335 16.0125 49.3763 9.78526 46.1435 9.59655ZM33.4525 5.03619C33.9739 4.63781 34.6934 4.69023 35.0584 5.16199C35.413 5.63375 35.267 6.34663 34.7456 6.74501C34.2137 7.15387 33.4942 7.10145 33.1396 6.62969C32.7851 6.15793 32.9206 5.44505 33.4525 5.03619Z"/>
							</mask>
							<path d="M70.6497 1C71.3797 1 71.9011 2.03788 72.0054 3.72574C72.1261 5.48756 72.2669 9.16383 72.3864 12.8363L72.4147 13.7166C72.5398 17.6689 72.6363 21.4378 72.6519 22.6067C72.6519 22.6591 72.6519 22.8373 72.7875 22.8373C72.8605 22.8373 72.9022 22.7849 72.9439 22.7325C73.4966 21.8938 74.8836 19.8495 75.7491 18.9584C76.3852 18.2979 76.9066 17.9939 77.4593 17.9939C77.8556 17.9939 78.2832 18.1512 78.7837 18.4866C79.2008 18.7697 79.5867 19.0737 79.9621 19.3568C80.7025 19.9334 81.4116 20.4785 82.2042 20.7511C82.8716 20.9817 84.0082 21.0342 84.8425 21.0342C85.3013 21.0342 85.8123 21.0132 86 21.0027L85.6454 22.9422C85.489 22.9527 84.9572 22.9631 84.4566 22.9631C83.6745 22.9631 82.5691 22.9212 81.714 22.6801C80.4105 22.3236 79.2634 21.6317 78.5751 21.1285L78.231 20.8874C77.5845 20.4366 77.1256 20.4366 76.7294 20.8664C76.4687 21.1495 75.5718 22.4914 74.7793 23.6865L73.9138 24.9655C73.4445 25.6574 72.7771 26.1082 72.2244 26.1082C71.7447 26.1082 71.3589 25.7937 71.1086 25.1752C70.818 24.478 70.5901 19.8912 70.4356 15.0605L70.4118 14.2963C70.4002 13.9137 70.3891 13.5308 70.3784 13.1494L70.3577 12.389C70.3076 10.4955 70.2691 8.66875 70.243 7.1329V7.11194C70.243 6.96517 70.1596 6.90227 70.0762 6.90227C70.0032 6.90227 69.9302 6.97565 69.8989 7.08049L69.8051 7.48935C68.4077 13.5594 65.0811 28.0582 64.5284 29.8194C64.1113 31.1508 63.3813 32 62.6618 32C62.1925 32 61.7858 31.6121 61.5042 30.9097C60.9098 29.4001 60.4406 27.1356 60.1381 25.6889L59.8983 24.6091C59.7627 24.0534 59.5959 23.6865 59.2413 23.6865C58.9806 23.6865 58.6469 23.8857 58.1776 24.2212C57.2391 24.8921 55.6853 25.8671 54.0064 25.8671H37.5612L37.9366 23.7809H53.5684C55.1639 23.7809 56.1337 22.9527 56.9784 22.2083C57.2808 21.9462 57.5624 21.7051 57.8544 21.5059C59.1788 20.6253 60.2737 20.6987 61.0141 21.747C61.6607 22.6696 61.9944 24.347 62.3802 26.2969C62.4949 26.905 62.62 27.6388 62.7556 28.2888C62.7973 28.4565 62.9955 28.4565 63.0267 28.2888C64.299 21.9777 67.2606 9.55462 68.6475 3.96686C69.2002 1.77579 70.0658 1 70.6497 1ZM38.0721 5.59182C38.8751 5.59182 39.4904 6.18938 39.3444 6.97565L39.0941 8.349C39.287 8.34376 39.8423 8.34114 40.3494 8.33983L40.6758 8.33913C40.7275 8.33905 40.7775 8.33897 40.8252 8.33891L41.3153 8.33852L41.0546 9.76429H38.8334L37.9679 14.6077C37.6759 16.2327 39.4278 15.8972 40.1369 15.6875C40.1369 15.6875 39.9388 16.7778 39.8345 17.2915C39.5008 17.4068 38.8021 17.4802 38.312 17.4802C36.8103 17.4802 35.5381 16.673 35.9552 14.5867L36.8103 9.76429H35.5381L35.7988 8.33852H37.071L37.5612 5.59182H38.0721ZM7.00662 4.63781C8.96712 4.63781 9.87437 5.17247 10.2498 5.43456C10.1455 5.73859 9.4781 6.92323 9.4051 7.08049C9.06097 6.84985 8.38314 6.25228 6.8502 6.25228C5.20255 6.25228 4.79585 7.44741 4.79585 7.90869C4.79585 10.299 9.34254 9.79574 9.34254 13.4964C9.34254 15.8028 7.22562 17.4697 4.66029 17.4697C3.12735 17.4697 1.90725 17.0085 1 16.3899C1.2607 15.8972 1.77168 14.9642 1.88639 14.7335C2.68936 15.4359 3.69047 15.7609 4.629 15.7609C5.83867 15.7609 7.24647 15.3101 7.24647 13.79C7.24647 11.4941 2.66851 11.9868 2.66851 8.26513C2.66851 6.69259 4.13888 4.63781 7.00662 4.63781ZM15.4534 8.13933C17.049 8.13933 18.0396 8.9885 18.3838 9.6909L18.6445 8.32804H20.5737L19.0199 17.2705H18.4568C17.7998 17.2705 17.1115 16.7568 17.2784 15.9286L17.3097 15.7924C16.7465 16.6835 15.808 17.4592 14.0665 17.4592C12.2103 17.4592 10.3749 15.7924 10.6982 12.9513C10.9798 10.4772 12.6483 8.13933 15.4534 8.13933ZM45.862 8.13933C47.4575 8.13933 48.4377 8.9885 48.7923 9.6909L49.053 8.32804H50.9822L49.418 17.2705H48.8549C48.2083 17.2705 47.5201 16.7568 47.6869 15.9286L47.7182 15.7924C47.1551 16.6835 46.2165 17.4592 44.4646 17.4592C42.6084 17.4592 40.7835 15.7924 41.1067 12.9618C41.3883 10.4772 43.0568 8.13933 45.862 8.13933ZM55.7375 8.04498C57.2183 8.04498 58.0629 8.51674 58.2506 8.66351L57.5311 10.0264C57.1035 9.82719 56.749 9.46026 55.5498 9.46026C54.7468 9.46026 54.0585 9.98444 54.0585 10.5715C54.0585 12.0602 57.6458 11.7771 57.6458 14.419C57.6458 15.9811 55.9982 17.3754 53.8708 17.3754C52.2023 17.3754 51.2429 16.7464 50.8466 16.4738C51.0135 16.2012 51.4932 15.3206 51.587 15.1529C52.1085 15.4988 52.8489 15.9286 53.7561 15.9286C54.8198 15.9286 55.6123 15.4045 55.6123 14.6287C55.6123 13.0666 52.0772 13.465 52.0772 10.8965C52.0772 9.65945 53.2556 8.04498 55.7062 8.04498H55.7375ZM33.1709 8.31755C33.9739 8.31755 34.5787 8.91512 34.4431 9.70139L33.077 17.281H31.054L32.6599 8.31755H33.1709ZM27.5918 8.13933C29.3021 8.13933 30.397 9.52317 30.0216 11.6618L29.0101 17.281H26.987L27.9777 11.7562C28.2905 10.0788 27.2581 9.74332 26.768 9.74332C25.7669 9.74332 24.3278 10.2885 23.8898 12.6368L23.0556 17.281H21.0325L22.6384 8.32804H23.1494C23.7021 8.32804 24.5259 8.76835 24.3487 9.74332C25.0474 8.7998 25.9129 8.13933 27.5918 8.13933ZM15.735 9.59655C12.5753 9.41833 11.6472 15.6666 14.6296 15.8343C17.9249 16.0125 18.9782 9.78526 15.735 9.59655ZM46.1435 9.59655C42.9734 9.42881 42.0557 15.6666 45.0277 15.8343C48.3335 16.0125 49.3763 9.78526 46.1435 9.59655ZM33.4525 5.03619C33.9739 4.63781 34.6934 4.69023 35.0584 5.16199C35.413 5.63375 35.267 6.34663 34.7456 6.74501C34.2137 7.15387 33.4942 7.10145 33.1396 6.62969C32.7851 6.15793 32.9206 5.44505 33.4525 5.03619Z" fill="#0079C8"/>
							<path d="M70.6497 1C71.3797 1 71.9011 2.03788 72.0054 3.72574C72.1261 5.48756 72.2669 9.16383 72.3864 12.8363L72.4147 13.7166C72.5398 17.6689 72.6363 21.4378 72.6519 22.6067C72.6519 22.6591 72.6519 22.8373 72.7875 22.8373C72.8605 22.8373 72.9022 22.7849 72.9439 22.7325C73.4966 21.8938 74.8836 19.8495 75.7491 18.9584C76.3852 18.2979 76.9066 17.9939 77.4593 17.9939C77.8556 17.9939 78.2832 18.1512 78.7837 18.4866C79.2008 18.7697 79.5867 19.0737 79.9621 19.3568C80.7025 19.9334 81.4116 20.4785 82.2042 20.7511C82.8716 20.9817 84.0082 21.0342 84.8425 21.0342C85.3013 21.0342 85.8123 21.0132 86 21.0027L85.6454 22.9422C85.489 22.9527 84.9572 22.9631 84.4566 22.9631C83.6745 22.9631 82.5691 22.9212 81.714 22.6801C80.4105 22.3236 79.2634 21.6317 78.5751 21.1285L78.231 20.8874C77.5845 20.4366 77.1256 20.4366 76.7294 20.8664C76.4687 21.1495 75.5718 22.4914 74.7793 23.6865L73.9138 24.9655C73.4445 25.6574 72.7771 26.1082 72.2244 26.1082C71.7447 26.1082 71.3589 25.7937 71.1086 25.1752C70.818 24.478 70.5901 19.8912 70.4356 15.0605L70.4118 14.2963C70.4002 13.9137 70.3891 13.5308 70.3784 13.1494L70.3577 12.389C70.3076 10.4955 70.2691 8.66875 70.243 7.1329V7.11194C70.243 6.96517 70.1596 6.90227 70.0762 6.90227C70.0032 6.90227 69.9302 6.97565 69.8989 7.08049L69.8051 7.48935C68.4077 13.5594 65.0811 28.0582 64.5284 29.8194C64.1113 31.1508 63.3813 32 62.6618 32C62.1925 32 61.7858 31.6121 61.5042 30.9097C60.9098 29.4001 60.4406 27.1356 60.1381 25.6889L59.8983 24.6091C59.7627 24.0534 59.5959 23.6865 59.2413 23.6865C58.9806 23.6865 58.6469 23.8857 58.1776 24.2212C57.2391 24.8921 55.6853 25.8671 54.0064 25.8671H37.5612L37.9366 23.7809H53.5684C55.1639 23.7809 56.1337 22.9527 56.9784 22.2083C57.2808 21.9462 57.5624 21.7051 57.8544 21.5059C59.1788 20.6253 60.2737 20.6987 61.0141 21.747C61.6607 22.6696 61.9944 24.347 62.3802 26.2969C62.4949 26.905 62.62 27.6388 62.7556 28.2888C62.7973 28.4565 62.9955 28.4565 63.0267 28.2888C64.299 21.9777 67.2606 9.55462 68.6475 3.96686C69.2002 1.77579 70.0658 1 70.6497 1ZM38.0721 5.59182C38.8751 5.59182 39.4904 6.18938 39.3444 6.97565L39.0941 8.349C39.287 8.34376 39.8423 8.34114 40.3494 8.33983L40.6758 8.33913C40.7275 8.33905 40.7775 8.33897 40.8252 8.33891L41.3153 8.33852L41.0546 9.76429H38.8334L37.9679 14.6077C37.6759 16.2327 39.4278 15.8972 40.1369 15.6875C40.1369 15.6875 39.9388 16.7778 39.8345 17.2915C39.5008 17.4068 38.8021 17.4802 38.312 17.4802C36.8103 17.4802 35.5381 16.673 35.9552 14.5867L36.8103 9.76429H35.5381L35.7988 8.33852H37.071L37.5612 5.59182H38.0721ZM7.00662 4.63781C8.96712 4.63781 9.87437 5.17247 10.2498 5.43456C10.1455 5.73859 9.4781 6.92323 9.4051 7.08049C9.06097 6.84985 8.38314 6.25228 6.8502 6.25228C5.20255 6.25228 4.79585 7.44741 4.79585 7.90869C4.79585 10.299 9.34254 9.79574 9.34254 13.4964C9.34254 15.8028 7.22562 17.4697 4.66029 17.4697C3.12735 17.4697 1.90725 17.0085 1 16.3899C1.2607 15.8972 1.77168 14.9642 1.88639 14.7335C2.68936 15.4359 3.69047 15.7609 4.629 15.7609C5.83867 15.7609 7.24647 15.3101 7.24647 13.79C7.24647 11.4941 2.66851 11.9868 2.66851 8.26513C2.66851 6.69259 4.13888 4.63781 7.00662 4.63781ZM15.4534 8.13933C17.049 8.13933 18.0396 8.9885 18.3838 9.6909L18.6445 8.32804H20.5737L19.0199 17.2705H18.4568C17.7998 17.2705 17.1115 16.7568 17.2784 15.9286L17.3097 15.7924C16.7465 16.6835 15.808 17.4592 14.0665 17.4592C12.2103 17.4592 10.3749 15.7924 10.6982 12.9513C10.9798 10.4772 12.6483 8.13933 15.4534 8.13933ZM45.862 8.13933C47.4575 8.13933 48.4377 8.9885 48.7923 9.6909L49.053 8.32804H50.9822L49.418 17.2705H48.8549C48.2083 17.2705 47.5201 16.7568 47.6869 15.9286L47.7182 15.7924C47.1551 16.6835 46.2165 17.4592 44.4646 17.4592C42.6084 17.4592 40.7835 15.7924 41.1067 12.9618C41.3883 10.4772 43.0568 8.13933 45.862 8.13933ZM55.7375 8.04498C57.2183 8.04498 58.0629 8.51674 58.2506 8.66351L57.5311 10.0264C57.1035 9.82719 56.749 9.46026 55.5498 9.46026C54.7468 9.46026 54.0585 9.98444 54.0585 10.5715C54.0585 12.0602 57.6458 11.7771 57.6458 14.419C57.6458 15.9811 55.9982 17.3754 53.8708 17.3754C52.2023 17.3754 51.2429 16.7464 50.8466 16.4738C51.0135 16.2012 51.4932 15.3206 51.587 15.1529C52.1085 15.4988 52.8489 15.9286 53.7561 15.9286C54.8198 15.9286 55.6123 15.4045 55.6123 14.6287C55.6123 13.0666 52.0772 13.465 52.0772 10.8965C52.0772 9.65945 53.2556 8.04498 55.7062 8.04498H55.7375ZM33.1709 8.31755C33.9739 8.31755 34.5787 8.91512 34.4431 9.70139L33.077 17.281H31.054L32.6599 8.31755H33.1709ZM27.5918 8.13933C29.3021 8.13933 30.397 9.52317 30.0216 11.6618L29.0101 17.281H26.987L27.9777 11.7562C28.2905 10.0788 27.2581 9.74332 26.768 9.74332C25.7669 9.74332 24.3278 10.2885 23.8898 12.6368L23.0556 17.281H21.0325L22.6384 8.32804H23.1494C23.7021 8.32804 24.5259 8.76835 24.3487 9.74332C25.0474 8.7998 25.9129 8.13933 27.5918 8.13933ZM15.735 9.59655C12.5753 9.41833 11.6472 15.6666 14.6296 15.8343C17.9249 16.0125 18.9782 9.78526 15.735 9.59655ZM46.1435 9.59655C42.9734 9.42881 42.0557 15.6666 45.0277 15.8343C48.3335 16.0125 49.3763 9.78526 46.1435 9.59655ZM33.4525 5.03619C33.9739 4.63781 34.6934 4.69023 35.0584 5.16199C35.413 5.63375 35.267 6.34663 34.7456 6.74501C34.2137 7.15387 33.4942 7.10145 33.1396 6.62969C32.7851 6.15793 32.9206 5.44505 33.4525 5.03619Z" stroke="#0079C8" stroke-width="0.2" mask="url(#path-1-outside-1)"/>
						</svg> */}
							<img src={logoImage} width={widthLogoImage} height={heightLogoImage} alt={nameHeader} />
							<p>{nameHeader}</p>
						</span>
						<div className="idiomas">
							<div className="idiomaGB" title="Idioma Ingl�s"></div>
							<div className="idiomaES" title="Idioma Espa�ol"></div>
							<button className="sendButton" data-id="webchat-sendbox-send-button" type="button" title="Enviar" alt="Enviar">
								<svg viewBox="2 3 35 26" height="28" width="28">
									<path clipRule="evenodd" d="M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z" />
								</svg>
							</button>
						</div>
					</div>
					<button id="callSosButton" className="callIcon" style={styleCallIcon}><img src="./img/te_llamamos.svg" alt="Save icon"></img><span style={{ position: "relative", top: "-8px" }}>{textPanicButtonBrabu}</span></button>
					<img className="speaker" style={styleSpeaker} src="./img/volumen-on.svg"></img>

					{children}
				</div>
			);

			// Seleccionamos el panel a mostrar texto/voice
			wcPanelTextVisibility = "visible";
			wcPanelVoiceVisibility = "hidden";

			videoInicial = <video muted playsInline preload="false" id="silence1" src={"./videos/" + avatar + "/silence1.mp4"} style={{ display: "block", margin: "auto", borderRadius: "125px" }}></video>

		} else {
			Header = ({ children }) => (
				<div className="wc-wrapper">
					<div className="wc-header" style={styleHeader}>
						<span className="wc-header-span" style={styleHeaderSpan}>
							<img src={logoImage} width={widthLogoImage} height={heightLogoImage} alt={nameHeader} />
							<p>{nameHeader}</p>
						</span>
						<button className="sendButton" data-id="webchat-sendbox-send-button" type="button" title="Enviar" alt="Enviar">
							<svg viewBox="2 3 35 26" height="28" width="28">
								<path clipRule="evenodd" d="M8.55 25.25l21.67-7.25H11zm2.41-9.47h19.26l-21.67-7.23zm-6 13l4-11.9L5 5l35.7 11.9z" />
							</svg>
						</button>
					</div>
					<img className="speaker" style={{ marginTop: "8px", zIndex: "9999" }} src="./img/volumen-on.svg"></img>
					{/* <img className="speaker" src="./img/speaker.png"></img> */}
					<img className="voiceChat-return" onClick={lanzarUIvozDesdeBack} src="./img/voiceChat-Return-voz.svg"></img>
					{/* <svg className="voiceChat-return" x="0px" y="0px" viewBox="0 0 26.9 28.3" onClick={lanzarUIvozDesdeBack}>
						<g>
							<path className="stspeaker" d="M-45.1,5.9c0.9-0.9,2-1.6,3.2-2.2c1.2-0.5,2.6-0.8,4-0.8l0,0c0.2,0,0.3,0,0.5,0l-2.9-3v2.6
							C-46.8,2.6-52,8.7-52,15.1c0,0.5,0,0.9,0.1,1.3c0.4-2.5,2-5,4.4-6.7c0.1-0.2,0.1-0.4,0.2-0.6C-46.8,7.9-46.1,6.9-45.1,5.9z"/>
							<path className="stspeaker" d="M-25.1,13.2c0-0.5,0-0.9-0.1-1.3c-0.7,4.6-5.6,9.1-11.6,9.1v-2.6l-4.8,5l4.8,5v-2.6
							C-30.4,25.7-25.1,19.6-25.1,13.2z"/>
							<path className="stspeaker" d="M-42.7,22.3l0.7-0.7c-0.3-0.1-0.6-0.3-0.9-0.5c-2.8-1.6-4.3-4.9-4.2-4.9c-0.2,0.3-0.3,0.5-0.4,0.8
							c-0.3,0.8-0.5,1.6-0.5,2.4c0,0.6,0.1,1.1,0.2,1.6c0.2,0.5,0.4,1,0.6,1.5l-1.1,3.3l3.3-1.1c0.5,0.3,1,0.4,1.5,0.6
							c0.5,0.1,1,0.2,1.5,0.2c0.1,0,0.3,0,0.4,0l-1.1-1.1C-43.2,23.8-43.2,22.9-42.7,22.3z"/>
							<path className="stspeaker" d="M-36.8,16.9c0.2,0,0.4,0,0.6,0.1c0.6,0.2,0.9,0.8,0.9,1.4v1c1.9-0.3,3.6-1,5-2.1c0.3-0.6,0.6-1.1,0.8-1.8
							c0.2-0.8,0.3-1.5,0.3-2.3c0-1.2-0.2-2.3-0.7-3.4c-0.5-1-1.1-2-1.9-2.7c-0.8-0.8-1.7-1.4-2.8-1.9c-1.1-0.4-2.2-0.7-3.4-0.7
							c-1.2,0-2.3,0.2-3.4,0.7c-1,0.5-2,1.1-2.8,1.9c-0.7,0.7-1.3,1.6-1.8,2.7c-0.5,1-0.7,2.2-0.7,3.4s0.2,2.3,0.7,3.4
							c0.5,1,1.1,2,1.9,2.7c0.8,0.8,1.7,1.4,2.7,1.8l3.6-3.7C-37.6,17-37.2,16.9-36.8,16.9z"/>
						</g>
						<g id="Page-2">
							<g id="Group" transform="translate(-3.000000, -2.000000)">
								<g id="chat-solid">
									<path id="path-1_1_" className="stspeaker" d="M12.8,2.9c-1.4,0.6-2.6,1.4-3.7,2.5C8.1,6.4,7.2,7.6,6.6,9c-0.6,1.4-0.9,2.9-0.9,4.5
									c0,1.6,0.3,3.1,0.9,4.5c0.6,1.4,1.4,2.6,2.5,3.6c1,1,2.3,1.9,3.7,2.5c1.4,0.6,2.9,0.9,4.5,0.9c1,0,2-0.1,2.9-0.4
									c0.9-0.3,1.8-0.6,2.7-1l6.4,2l-2.1-6.1c0.5-0.9,0.9-1.8,1.2-2.8c0.3-1,0.4-2,0.4-3.1c0-1.6-0.3-3.1-0.9-4.5
									c-0.6-1.4-1.4-2.6-2.5-3.6c-1-1-2.3-1.9-3.7-2.5C20.4,2.3,18.9,2,17.3,2C15.7,2,14.2,2.3,12.8,2.9z M5.1,17.6
									c-0.2,0.3-0.4,0.7-0.5,1.1c-0.4,1-0.6,2-0.6,3.1c0,0.8,0.1,1.5,0.3,2.2c0.2,0.7,0.5,1.4,0.8,2l-1.4,4.3l4.4-1.4
									c0.6,0.3,1.2,0.6,1.8,0.7c0.6,0.2,1.3,0.3,2,0.3c1.1,0,2.1-0.2,3.1-0.6c1-0.4,1.8-1,2.5-1.7c0.5-0.5,1-1.2,1.4-1.9
									c-1.1,0.3-4.5,0.6-8.2-1.6S5.1,17.6,5.1,17.6z"/>
								</g>
							</g>
						</g>
					</svg> */}
					{children}
				</div >
			);

			// Seleccionamos el panel a mostrar texto/voice
			wcPanelTextVisibility = "hidden";
			wcPanelVoiceVisibility = "visible";

		}

		return (
			<div style={{ width: "100%", height: "100%" }}>
				<div className="voiceChat-cover" style={{ visibility: wcPanelVoiceVisibility }}>
					<div className="voiceChat-body voiceChat-bodyFullHeight">
						{/* Inicio de icono que se superpone sobre el avatar cuando está escuchando el mensaje, por defecto está con Display: "None"*/}
						<div className="voiceChat-listening">
							<div className="voiceChat-listeningContent">
								<svg id="IconoVoz" x="0px" y="0px" viewBox="20 20 60 60" width="60px" height="60px">
									<rect x="19.5" y="30" width="11" height="30" fill="#ffffff" rx="5" ry="5">
										<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="10;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
										<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="80;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
									</rect>
									<rect x="44.5" y="30" width="11" height="40" fill="#ffffff" rx="5" ry="5">
										<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="15;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
										<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="70;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
									</rect>
									<rect x="69.5" y="30" width="11" height="30" fill="#ffffff" rx="5" ry="5">
										<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="15;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
										<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="70;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
									</rect>
								</svg>
								<p>{escuchando}</p>
							</div>
							{/* Fin del icono que se superpone sobre el avatar */}

						</div>
						<div className="voiceChat-avatar">
							<div className="voiceChat-imagen" style={{ backgroundImage: "url(./img/avatar" + avatar + ".jpg)" }}>		
								{ videoInicial }
								<video muted playsInline preload="auto" id="silence2" src={"./videos/" + avatar + "/silence2.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="silence3" src={"./videos/" + avatar + "/silence3.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="silence4" src={"./videos/" + avatar + "/silence4.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="silence9" src={"./videos/" + avatar + "/silence9.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="speak1" src={"./videos/" + avatar + "/speak1.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="speak2" src={"./videos/" + avatar + "/speak2.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="speak3" src={"./videos/" + avatar + "/speak3.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
								<video muted playsInline preload="auto" id="speak4" src={"./videos/" + avatar + "/speak4.mp4"} style={{ display: "none", margin: "auto", borderRadius: "125px" }}></video>
							</div>
							<div className="voiceChat-animacionAvatarContainer">
								<div className="voiceChat-animacionAnimationContainer">
									<div className="voiceChat-animacionAvatarDiv voiceChat-animacionAvatar"></div>
									<div className="voiceChat-animacionAvatarDiv voiceChat-animacionAvatar"></div>
									<div className="voiceChat-animacionAvatarDiv voiceChat-animacionAvatar"></div>
									<div className="voiceChat-animacionAvatarDiv voiceChat-animacionAvatar"></div>
									<div className="voiceChat-animacionAvatarDiv voiceChat-animacionAvatar"></div>
								</div>
							</div>
						</div>

						{/* Cuerpo principal de la transcripcción de mensajes en la interacción por voz, aparece cuando se selecciona interacción por voz, por defecto en Display: "None" */}
						<div className="voiceChat-mensajes" style={{ display: "inline" }}>
						</div>
						{/* Fin cuerpo principal de la transcripcción de mensajes en la interacción por voz, aparece cuando se selecciona interacción por voz, por defecto en Display: "None" */}

						{/* Botón de ida a la pantalla de interacción por escrito desde la interacción por voz, aparece cuando se selecciona interacción por voz, por defecto en display: "None" */}
						<div className="voiceChat-exit" style={{ display: "inline" }} onClick={lanzarUItexto}>
							<svg id="Capa_1" x="0px" y="0px" viewBox="0 0 40 40">
								<g>
									<g>
										<path d="M40,19.6c0-0.6,0-1.2-0.1-1.8c-0.9,6.1-7.4,12-15.3,12v-3.4L18.3,33l6.3,6.6v-3.4C33.1,36.1,40,28.1,40,19.6z" />
									</g>
									<g>
										<path d="M0,20.4c0,0.6,0,1.2,0.1,1.8c0.9-6.1,7.4-12,15.3-12v3.4L21.7,7l-6.3-6.6v3.4C6.9,3.9,0,11.9,0,20.4z" />
									</g>
									<g>
										<path className="st0" d="M31.3,20h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1
										C30.2,19.5,30.7,20,31.3,20z"/>
										<path className="st0" d="M19.4,22.2c0,0.6,0.5,1.1,1.1,1.1h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1
										C19.9,21.1,19.4,21.6,19.4,22.2z"/>
										<path className="st0" d="M27,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H27c-0.6,0-1.1,0.5-1.1,1.1
										C25.9,16.3,26.4,16.8,27,16.8z"/>
										<path className="st0" d="M27,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H27c-0.6,0-1.1,0.5-1.1,1.1C25.9,19.5,26.4,20,27,20z
										"/>
										<path className="st0" d="M22.7,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
										C21.6,16.3,22.1,16.8,22.7,16.8z"/>
										<path className="st0" d="M31.3,16.8h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1
										C30.2,16.3,30.7,16.8,31.3,16.8z"/>
										<path className="st0" d="M17.3,24.3c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h3.3l2.1-2.2H17.3z" />
										<path className="st0" d="M27,23.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.5,0.4,1,0.9,1
										c0.1,0,0.2,0,0.3,0H27z"/>
										<path className="st0" d="M34.5,22.5c0-0.1,0.1-0.2,0.1-0.3c0-0.6-0.5-1.1-1.1-1.1h-3.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1
										h3.2c0.1,0,0.2,0,0.3-0.1C34,23,34.2,22.7,34.5,22.5z"/>
										<path className="st0" d="M33.5,26.5c0.6,0,1.1-0.5,1.1-1.1c0,0,0-0.1,0-0.1c-0.5,0.4-1.1,0.8-1.7,1.2H33.5z" />
										<path className="st0" d="M22.7,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
										C21.6,19.5,22.1,20,22.7,20z"/>
										<path className="st0" d="M9.7,23.2h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
										C8.6,22.8,9.1,23.2,9.7,23.2z"/>
										<path className="st0" d="M14,24.3H9.7c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1H14c0.6,0,1.1-0.5,1.1-1.1
										C15.1,24.8,14.6,24.3,14,24.3z"/>
										<path className="st0" d="M9.7,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1C8.6,19.5,9.1,20,9.7,20
										z"/>
										<path className="st0" d="M18.3,22.2c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h2.2
										C17.9,23.2,18.3,22.8,18.3,22.2z"/>
										<path className="st0" d="M18.3,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
										C17.3,16.3,17.8,16.8,18.3,16.8z"/>
										<path className="st0" d="M14,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H14c-0.6,0-1.1,0.5-1.1,1.1C13,19.5,13.4,20,14,20z"
										/>
										<path className="st0" d="M18.3,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
										C17.3,19.5,17.8,20,18.3,20z"/>
										<path className="st0" d="M9.7,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
										C8.6,16.3,9.1,16.8,9.7,16.8z"/>
										<path className="st0" d="M14,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H14c-0.6,0-1.1,0.5-1.1,1.1
										C13,16.3,13.4,16.8,14,16.8z"/>
										<g>
											<path d="M9.6,30.7c-2.9,0-5.2-2.3-5.2-5.2v-9.9c0-2.9,2.3-5.2,5.2-5.2h24c2.9,0,5.2,2.3,5.2,5.2v0.8c0,0.1,0,0.1,0,0.2
											c0,0,0,0.1,0,0.1c-0.3,2.2-1.6,4.6-3.6,6.5c-0.1,0.1-0.3,0.2-0.5,0.3c-0.1,0.2-0.2,0.3-0.3,0.5c-0.5,0.4-1.1,0.8-1.6,1.2
											c-0.2,0.1-0.3,0.2-0.5,0.2h-3.1c0,0-0.1,0-0.1,0.1c0.2,0.3,0.3,0.6,0.2,1c-0.1,0.3-0.3,0.6-0.7,0.7c-0.6,0.2-1.2,0.3-1.7,0.4
											c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5-0.1-0.6-0.2c-0.2-0.2-0.4-0.5-0.4-0.8v-1.1c0-0.5-0.3-0.9-0.7-1.1c-0.1,0-0.1,0-0.2-0.1
											c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0-0.1,0c-0.3,0-0.6,0.1-0.8,0.4L23.3,25c-0.2,0.2-0.4,0.3-0.7,0.3h-5.3c0,0-0.1,0-0.1,0.1
											s0,0.1,0.1,0.1h3.3c0.4,0,0.8,0.2,0.9,0.6c0.2,0.4,0.1,0.8-0.2,1.1l-3.1,3.2c-0.2,0.2-0.4,0.3-0.7,0.3H9.6z M9.7,25.3
											C9.7,25.3,9.6,25.4,9.7,25.3c-0.1,0.1,0,0.2,0,0.2H14c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H9.7z M15.1,22.1
											C15.1,22.1,15,22.1,15.1,22.1c-0.1,0.1,0,0.2,0,0.2h2.2c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H15.1z M30.2,22.1
											C30.2,22.1,30.2,22.1,30.2,22.1c-0.1,0.1,0,0.2,0,0.2h3.2c0,0,0,0,0,0c0,0,0,0,0,0c0-0.1,0-0.1-0.1-0.1H30.2z M27,22.2
											C27,22.2,27.1,22.2,27,22.2c0.1-0.1,0-0.2,0-0.2h-2.2c0,0-0.1,0-0.1,0.1c0.1,0,0.2,0,0.3,0.1H27z M20.5,22.1
											C20.5,22.1,20.4,22.1,20.5,22.1c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H20.5z M9.7,22.1
											C9.7,22.1,9.6,22.1,9.7,22.1c-0.1,0.1,0,0.2,0,0.2h2.2c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H9.7z M31.3,18.8
											C31.3,18.8,31.2,18.9,31.3,18.8c-0.1,0.1,0,0.2,0,0.2h2.2c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H31.3z M27,18.8
											C26.9,18.8,26.9,18.9,27,18.8c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H27z M22.7,18.8
											C22.6,18.8,22.6,18.9,22.7,18.8c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H22.7z M18.3,18.8
											C18.3,18.8,18.3,18.9,18.3,18.8c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H18.3z M14,18.8
											C14,18.8,14,18.9,14,18.8C14,19,14,19,14,19h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H14z M9.7,18.8C9.7,18.8,9.6,18.9,9.7,18.8
											c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1c0,0,0-0.1-0.1-0.1H9.7z M31.3,15.6C31.3,15.6,31.2,15.6,31.3,15.6
											c-0.1,0.1,0,0.2,0,0.2h2.2c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H31.3z M27,15.6C26.9,15.6,26.9,15.6,27,15.6c-0.1,0.1,0,0.2,0,0.2
											h1.1c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H27z M22.7,15.6C22.6,15.6,22.6,15.6,22.7,15.6c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1
											s0-0.1-0.1-0.1H22.7z M18.3,15.6C18.3,15.6,18.3,15.6,18.3,15.6c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H18.3z
											M14,15.6C14,15.6,14,15.6,14,15.6c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H14z M9.7,15.6
											C9.7,15.6,9.6,15.6,9.7,15.6c-0.1,0.1,0,0.2,0,0.2h1.1c0,0,0.1,0,0.1-0.1s0-0.1-0.1-0.1H9.7z"/>
											<path className="st1" d="M33.6,11.4c2.3,0,4.2,1.9,4.2,4.2v0.8c0,0,0,0,0,0.1c-0.3,2.1-1.5,4.3-3.3,6c0-0.1,0.1-0.2,0.1-0.3
											c0-0.6-0.5-1.1-1.1-1.1h-3.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h3.2c0.1,0,0.2,0,0.3-0.1c-0.5,0.4-1,0.8-1.5,1.1h-3.1
											c-0.6,0-1.1,0.5-1.1,1.1c0,0.3,0.1,0.5,0.3,0.7c-0.5,0.1-1,0.3-1.6,0.4v-1.1c0-0.9-0.5-1.7-1.4-2c-0.1-0.1-0.3-0.1-0.4-0.1h2
											c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1c0,0.5,0.4,1,0.9,1c0,0,0,0-0.1,0
											c-0.6,0-1.1,0.2-1.6,0.7l-0.4,0.5h-5.3c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1h3.3l-3.1,3.2H9.6c-2.3,0-4.2-1.9-4.2-4.2
											v-9.9c0-2.3,1.9-4.2,4.2-4.2H33.6 M31.3,16.8h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1
											C30.2,16.3,30.7,16.8,31.3,16.8 M27,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H27c-0.6,0-1.1,0.5-1.1,1.1
											C25.9,16.3,26.4,16.8,27,16.8 M22.7,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
											C21.6,16.3,22.1,16.8,22.7,16.8 M18.3,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
											C17.3,16.3,17.8,16.8,18.3,16.8 M14,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H14c-0.6,0-1.1,0.5-1.1,1.1
											C13,16.3,13.4,16.8,14,16.8 M9.7,16.8h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
											C8.6,16.3,9.1,16.8,9.7,16.8 M31.3,20h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1
											C30.2,19.5,30.7,20,31.3,20 M27,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H27c-0.6,0-1.1,0.5-1.1,1.1
											C25.9,19.5,26.4,20,27,20 M22.7,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
											C21.6,19.5,22.1,20,22.7,20 M18.3,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
											C17.3,19.5,17.8,20,18.3,20 M14,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H14c-0.6,0-1.1,0.5-1.1,1.1
											C13,19.5,13.4,20,14,20 M9.7,20h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
											C8.6,19.5,9.1,20,9.7,20 M20.5,23.2h1.1c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-1.1c-0.6,0-1.1,0.5-1.1,1.1
											C19.4,22.8,19.9,23.2,20.5,23.2 M15.1,23.2h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1h-2.2c-0.6,0-1.1,0.5-1.1,1.1
											C14,22.8,14.5,23.2,15.1,23.2 M9.7,23.2h2.2c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
											C8.6,22.8,9.1,23.2,9.7,23.2 M9.7,26.5H14c0.6,0,1.1-0.5,1.1-1.1c0-0.6-0.5-1.1-1.1-1.1H9.7c-0.6,0-1.1,0.5-1.1,1.1
											C8.6,26,9.1,26.5,9.7,26.5 M33.6,9.4C33.6,9.4,33.6,9.4,33.6,9.4h-24c-3.4,0-6.2,2.8-6.2,6.2v9.9c0,3.4,2.8,6.2,6.2,6.2h7.8
											c0.5,0,1.1-0.2,1.4-0.6l3.1-3.2c0.4-0.4,0.6-1,0.6-1.5h0.1c0.5,0,1.1-0.2,1.4-0.6l0.4-0.5c0,0,0.1,0,0.1,0c0,0,0,0,0,0
											c0,0,0,0,0,0c0.1,0,0.1,0.1,0.1,0.2v1.1c0,0.6,0.3,1.1,0.7,1.5c0.4,0.3,0.8,0.5,1.3,0.5c0.1,0,0.2,0,0.3,0
											c0.6-0.1,1.1-0.2,1.8-0.4c0.6-0.2,1.2-0.7,1.4-1.3c0-0.1,0.1-0.2,0.1-0.4h1.9c0.4,0,0.8-0.1,1.1-0.3c0.6-0.4,1.2-0.8,1.7-1.3
											c0.2-0.1,0.3-0.3,0.4-0.4c0.2-0.1,0.3-0.2,0.5-0.3c2.1-2.1,3.5-4.6,3.9-7.1c0,0,0-0.1,0-0.1c0-0.1,0-0.2,0-0.3v-0.8
											C39.8,12.2,37,9.4,33.6,9.4L33.6,9.4z"/>
										</g>
										<path className="st1" d="M25,23.2c-0.1,0-0.2,0-0.3,0c0.1,0,0.1,0,0.2,0H25z" />
									</g>
								</g>
							</svg>
						</div>
						{/* Fin botón de ida a la pantalla de interacción por escrito desde la interacción por voz, aparece cuando se selecciona interacción por voz, por defecto en display: "None" */}

						<div className="voiceChat-IconoVozContainer">
							{/* Animacion sendTyping */}

							<div id="voiceSendTyping">
								<img src="data:image/svg+xml;base64,PHN2ZyBjbGFzcz0ibGRzLXR5cGluZyIgd2lkdGg9IjcwcHgiIGhlaWdodD0iNTBweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmlld0JveD0iMCAwIDEwMCAxMDAiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiBzdHlsZT0iYmFja2dyb3VuZDogbm9uZTsiPjxjaXJjbGUgY3g9IjI0LjUiIGN5PSI0OC40MjYzIiByPSI2IiBmaWxsPSIjMjI1NTZFIj4gIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN5IiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswLjUgMCAxIDAuNTswLjUgMC41IDAuNSAwLjUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjYyLjU7MzcuNTs2Mi41OzYyLjUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzEiIGR1cj0iMXMiIGJlZ2luPSItMC41cyIvPjwvY2lyY2xlPiA8Y2lyY2xlIGN4PSI0MS41IiBjeT0iNjIuNSIgcj0iNiIgZmlsbD0iIzQ3OTlCNyI+ICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJjeSIgY2FsY01vZGU9InNwbGluZSIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MC41IDAgMSAwLjU7MC41IDAuNSAwLjUgMC41IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSI2Mi41OzM3LjU7NjIuNTs2Mi41IiBrZXlUaW1lcz0iMDswLjI1OzAuNTsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMzc1cyIvPjwvY2lyY2xlPiA8Y2lyY2xlIGN4PSI1OC41IiBjeT0iNjIuNSIgcj0iNiIgZmlsbD0iIzZEQjNCRiI+ICA8YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJjeSIgY2FsY01vZGU9InNwbGluZSIga2V5U3BsaW5lcz0iMCAwLjUgMC41IDE7MC41IDAgMSAwLjU7MC41IDAuNSAwLjUgMC41IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSI2Mi41OzM3LjU7NjIuNTs2Mi41IiBrZXlUaW1lcz0iMDswLjI1OzAuNTsxIiBkdXI9IjFzIiBiZWdpbj0iLTAuMjVzIi8+PC9jaXJjbGU+IDxjaXJjbGUgY3g9Ijc1LjUiIGN5PSI2Mi41IiByPSI2IiBmaWxsPSIjOTRDRkM5Ij4gIDxhbmltYXRlIGF0dHJpYnV0ZU5hbWU9ImN5IiBjYWxjTW9kZT0ic3BsaW5lIiBrZXlTcGxpbmVzPSIwIDAuNSAwLjUgMTswLjUgMCAxIDAuNTswLjUgMC41IDAuNSAwLjUiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjYyLjU7MzcuNTs2Mi41OzYyLjUiIGtleVRpbWVzPSIwOzAuMjU7MC41OzEiIGR1cj0iMXMiIGJlZ2luPSItMC4xMjVzIi8+PC9jaXJjbGU+PC9zdmc+" />
							</div>

							{/* Fin animacion sendTyping */}

							{/* Boton de microfono para enviar mensajes por voz */}
							<div id="voiceChatIconVozIn" style={{ display: "inline" }}>
								<button id="buttonMensajeVoiceUI" onClick={enviarMensajeVoiceUI}>
									{/* <img id="IconoVozIn" src="./img/voiceChat-microphone.svg" className="voiceChat-IconoVozIn">
									</img> */}
									<svg id="IconoVozIn" x="0px" y="0px" viewBox="0 0 30 30" className="voiceChat-IconoVozIn">
										<g>
											<path d="M15,24c3.8,0,6.8-3,6.8-6.8V6.8C21.8,3,18.8,0,15,0S8.2,3,8.2,6.8v10.5C8.2,21,11.2,24,15,24z M9.8,6.8   c0-2.9,2.4-5.3,5.2-5.3s5.2,2.4,5.2,5.3v10.5c0,2.9-2.4,5.2-5.2,5.2s-5.2-2.4-5.2-5.2V6.8z" />
											<path d="M24.8,18h-1.5c0,4.2-3.8,7.5-8.2,7.5S6.8,22.2,6.8,18H5.2c0,4.7,3.9,8.6,9,9v1.5h-1.6c-0.5,0-0.8,0.3-0.8,0.8   s0.3,0.8,0.8,0.8h4.8c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-1.7V27C20.9,26.6,24.8,22.7,24.8,18z" />
										</g>
									</svg>
									<svg className="escuchandoEnBoton" x="0px" y="0px" viewBox="20 20 60 60" width="30px" height="30px">
										<rect x="19.5" y="30" width="11" height="30" fill="#ffffff" rx="5" ry="5">
											<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="10;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
											<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="80;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.2s"></animate>
										</rect>
										<rect x="44.5" y="30" width="11" height="40" fill="#ffffff" rx="5" ry="5">
											<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="15;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
											<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="70;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1" begin="-0.1s"></animate>
										</rect>
										<rect x="69.5" y="30" width="11" height="30" fill="#ffffff" rx="5" ry="5">
											<animate attributeName="y" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="15;30;30" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
											<animate attributeName="height" repeatCount="indefinite" dur="1s" calcMode="spline" keyTimes="0;0.5;1" values="70;40;40" keySplines="0 0.5 0.5 1;0 0.5 0.5 1"></animate>
										</rect>
									</svg>
								</button>
							</div>
							{/* Fin boton de microfono */}

						</div>

					</div>
				</div >
				<div className="wc-chatview-panel" style={{ visibility: wcPanelTextVisibility }} ref={myRef}>
					<Header>
						<ReactWebChat
							className="chat"
							adaptiveCardsHostConfig={adaptiveCardsHostConfig}
							directLine={directLine}
							locale={localeBot}
							selectVoice={(voices, activity) => {
								if (isSafari || isIosChrome) {
									return voices.find(({ name }) => /Laura-Apollo/iu.test(name));
								}
								else {
									return voices.find(({ name }) => /Laura/iu.test(name));
								}
							}
							}
							webSpeechPonyfillFactory={webSpeechPonyfillFactory}
							store={store}
							cardActionMiddleware={cardActionMiddleware}
							activityMiddleware={activityMiddleware}
							styleSet={styleSet} />
					</Header>
				</div>
			</div >
		);

		function lanzarUIvozDesdeBack() {

			saniaSpeak = true;
			let wcChatMessages = document.getElementsByClassName("voiceChat-mensajes");
			let wcvoiceChatExit = document.getElementsByClassName("voiceChat-exit");
			let wcvoiceChatBody = document.getElementsByClassName("voiceChat-body");
			wcChatMessages[0].style.display = "inline";
			wcvoiceChatExit[0].style.display = "inline";
			let divBotonVoice = document.getElementById("voiceChatIconVozIn");
			divBotonVoice.style.display = 'inline';

			//Se comprueba si ha entrado desde un lado u otro y si ya se ha añadido la clase antes, si no, la añade
			if (wcvoiceChatBody[0].className != "voiceChat-body voiceChat-bodyFullHeight") {
				wcvoiceChatBody[0].className += ' voiceChat-bodyFullHeight';
			}

			let wcPanelText = document.getElementsByClassName("wc-chatview-panel");
			let wcPanelVoice = document.getElementsByClassName("voiceChat-cover");
			wcPanelText[0].style.visibility = "hidden";
			wcPanelVoice[0].style.visibility = "visible";

			// SE DESHABILITA EL SENDBOX
			let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
			if (campoTexto) { campoTexto.style.visibility = 'hidden'; }

		}

		function lanzarUItexto() {

			// PARAMOS LA SINTESIS
			stopSaniaSpeech();
			saniaSpeak = false;

			let wcPanelText = document.getElementsByClassName("wc-chatview-panel");
			let wcPanelVoice = document.getElementsByClassName("voiceChat-cover");
			wcPanelText[0].style.visibility = "visible";
			wcPanelVoice[0].style.visibility = "hidden";

			// SE HABILITA EL SENDBOX
			let campoTexto = document.querySelector('[data-id="webchat-sendbox-input"]');
			if (campoTexto) { campoTexto.style.visibility = 'visible'; }
			// OCULTAMOS EL SENDTYPING DE LA INTERFAZ DE VOZ
			let sendTypingVoice = document.getElementById('voiceSendTyping');
			if (sendTypingVoice) { sendTypingVoice.style.display = 'none'; }

		}

		function enviarMensajeVoiceUI() {
			let micButton = document.querySelector('[aria-controls="webchatSendBoxMicrophoneButton"]');
			if (micButton) {
				micButton.children[0].click();
				changeMicVoiceUI();
			} else {
				alert("No puedo acceder al microfono de tu dispositivo, por favor interactua por escrito con SanIA...");
			}

		}
	}
	else {
		return (
			<div style={{ width: "100%", height: "100%", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center", }}>
				<div className="contenedor_loading">
					<svg className="verde_arriba" x="0px" y="0px" viewBox="0 0 272 272">
						<g id="Group" transform="translate(27.500000, 27.500000)">
							<g id="Combined-Shape_2_">
								<path className="st0" d="M14.1,202.9c-16-16-21.7-38.5-15.4-60.2l6.2-21.2c2.5-8.5,2.5-17.5,0-26l-6.2-21.2
									C-7.6,52.5-1.9,30,14.1,14.1c16-16,38.5-21.7,60.2-15.4l21.2,6.2c8.5,2.5,17.5,2.5,26,0l21.2-6.2c21.7-6.3,44.2-0.6,60.2,15.4
									c16,16,21.7,38.5,15.4,60.2l-6.2,21.2c-2.5,8.5-2.5,17.5,0,26l6.2,21.2c6.3,21.7,0.6,44.2-15.4,60.2c-16,16-38.5,21.7-60.2,15.4
									l-21.2-6.2c-8.5-2.5-17.5-2.5-26,0l-21.2,6.2C52.6,224.6,30.1,218.9,14.1,202.9z M192.6,24.4c-12.2-12.2-29.3-16.5-45.8-11.7
									l-21.2,6.2c-11.2,3.3-23,3.3-34.2,0l-21.2-6.2c-16.5-4.8-33.6-0.5-45.8,11.7C12.2,36.5,7.9,53.6,12.7,70.1l6.2,21.2
									c3.3,11.2,3.3,23,0,34.2l-6.2,21.2c-4.8,16.5-0.5,33.6,11.7,45.8c12.2,12.2,29.3,16.5,45.8,11.7l21.2-6.2c11.2-3.3,23-3.3,34.2,0
									l21.2,6.2c16.5,4.8,33.6,0.5,45.8-11.7c12.2-12.2,16.5-29.3,11.7-45.8l-6.2-21.2c-3.3-11.2-3.3-23,0-34.2l6.2-21.2
									C209.1,53.6,204.8,36.5,192.6,24.4z"/>
							</g>
							<g id="Combined-Shape">
								<path className="st1" d="M108.5-23.1c20.3,0,40.5,10.2,51.7,30.7l10.6,19.4c4.4,8.1,11.1,14.8,19.2,19.2l19.4,10.6
									c40.9,22.4,40.9,81.1,0,103.4L190,170.8c-8.1,4.4-14.8,11.1-19.2,19.2l-10.6,19.4C149,229.8,128.7,240,108.5,240
									c-20.3,0-40.5-10.2-51.7-30.7L46.1,190c-4.4-8.1-11.1-14.7-19.2-19.2L7.6,160.2c-40.9-22.3-40.9-81.1,0-103.4L27,46.1
									c8.1-4.4,14.8-11.1,19.2-19.2L56.7,7.5C67.9-12.9,88.2-23.1,108.5-23.1 M108.5,229.4c16.6,0,33.2-8.4,42.3-25.1l10.6-19.4
									c5.4-9.9,13.5-18,23.4-23.4l19.4-10.6c33.5-18.3,33.5-66.4,0-84.7l-19.4-10.6c-9.9-5.4-18-13.5-23.4-23.4l-10.6-19.4
									c-9.2-16.7-25.7-25.1-42.3-25.1S75.3-4.1,66.1,12.7L55.5,32.1C50.1,42,42,50.1,32.1,55.5L12.7,66.1c-33.5,18.3-33.5,66.4,0,84.7
									l19.4,10.6c9.9,5.4,18,13.5,23.4,23.4l10.6,19.4C75.3,221,91.9,229.4,108.5,229.4 M108.5-27L108.5-27C85.1-27,64.5-14.8,53.3,5.7
									L42.7,25.1c-4.1,7.5-10.2,13.6-17.6,17.6L5.7,53.3C-14.8,64.5-27,85.2-27,108.5c0,23.3,12.2,43.9,32.7,55.1l19.4,10.6
									c7.5,4.1,13.6,10.2,17.6,17.6l10.6,19.4c11.2,20.5,31.8,32.7,55.1,32.7c23.3,0,43.9-12.2,55.1-32.7l10.6-19.4
									c4.1-7.4,10.2-13.5,17.6-17.6l19.4-10.6c20.5-11.2,32.7-31.8,32.7-55.1c0-23.3-12.2-43.9-32.7-55.1l-19.4-10.6
									c-7.4-4.1-13.5-10.2-17.6-17.6L163.6,5.7C152.4-14.8,131.8-27,108.5-27L108.5-27z M108.5,225.5c-16.5,0-31-8.6-38.9-23.1L58.9,183
									c-5.8-10.5-14.4-19.2-25-25l-19.4-10.6c-14.5-7.9-23.1-22.4-23.1-38.9c0-16.5,8.6-31,23.1-38.9l19.4-10.6
									c10.6-5.8,19.2-14.4,25-25l10.6-19.4C77.4,0.1,92-8.5,108.5-8.5c16.5,0,31,8.6,38.9,23.1L158,33.9c5.8,10.6,14.4,19.2,25,25
									l19.4,10.6c14.5,7.9,23.1,22.5,23.1,38.9c0,16.5-8.6,31-23.1,38.9L183,158c-10.6,5.8-19.2,14.4-25,25l-10.6,19.4
									C139.5,216.9,124.9,225.5,108.5,225.5L108.5,225.5z"/>
								<path className="st2" d="M108.5,242c-22.6,0-42.6-11.8-53.4-31.7l-10.6-19.4c-4.2-7.8-10.6-14.1-18.4-18.4L6.6,161.9
									c-19.8-10.8-31.7-30.8-31.7-53.4c0-22.6,11.8-42.6,31.7-53.4L26,44.4c7.8-4.3,14.1-10.6,18.4-18.4L55,6.6
									c10.9-19.8,30.8-31.7,53.4-31.7c22.6,0,42.6,11.8,53.4,31.7L172.5,26c4.3,7.8,10.6,14.2,18.4,18.4L210.3,55
									c19.8,10.9,31.7,30.8,31.7,53.4c0,22.6-11.8,42.6-31.7,53.4l-19.4,10.6c-7.8,4.3-14.2,10.6-18.4,18.4l-10.6,19.4
									C151,230.2,131.1,242,108.5,242z M108.5-10.5c-17.2,0-32.4,9-40.6,24.1L57.2,33c-5.6,10.3-14,18.6-24.2,24.2L13.6,67.8
									c-15.1,8.3-24.1,23.5-24.1,40.7c0,17.2,9,32.4,24.1,40.6L33,159.7c10.2,5.6,18.6,14,24.2,24.2l10.6,19.4
									c8.3,15.1,23.5,24.1,40.6,24.1c17.2,0,32.4-9,40.6-24.1l10.6-19.4c5.6-10.2,14-18.6,24.2-24.2l19.4-10.6
									c15.1-8.2,24.1-23.4,24.1-40.6c0-17.2-9-32.4-24.1-40.7l-19.4-10.6c-10.2-5.6-18.6-14-24.2-24.2l-10.6-19.4
									C140.9-1.5,125.7-10.5,108.5-10.5z"/>
							</g>
						</g>
					</svg>
					<svg className="azul_abajo" x="0px" y="0px" viewBox="0 0 272 272">
						<g id="Group" transform="translate(27.500000, 27.500000)">
							<g id="Combined-Shape_2_">
								<path className="st3" d="M14.1,202.9c-16-16-21.7-38.5-15.4-60.2l6.2-21.2c2.5-8.5,2.5-17.5,0-26l-6.2-21.2
									C-7.6,52.5-1.9,30,14.1,14.1c16-16,38.5-21.7,60.2-15.4l21.2,6.2c8.5,2.5,17.5,2.5,26,0l21.2-6.2c21.7-6.3,44.2-0.6,60.2,15.4
									c16,16,21.7,38.5,15.4,60.2l-6.2,21.2c-2.5,8.5-2.5,17.5,0,26l6.2,21.2c6.3,21.7,0.6,44.2-15.4,60.2c-16,16-38.5,21.7-60.2,15.4
									l-21.2-6.2c-8.5-2.5-17.5-2.5-26,0l-21.2,6.2C52.6,224.6,30.1,218.9,14.1,202.9z M192.6,24.4c-12.2-12.2-29.3-16.5-45.8-11.7
									l-21.2,6.2c-11.2,3.3-23,3.3-34.2,0l-21.2-6.2c-16.5-4.8-33.6-0.5-45.8,11.7C12.2,36.5,7.9,53.6,12.7,70.1l6.2,21.2
									c3.3,11.2,3.3,23,0,34.2l-6.2,21.2c-4.8,16.5-0.5,33.6,11.7,45.8c12.2,12.2,29.3,16.5,45.8,11.7l21.2-6.2c11.2-3.3,23-3.3,34.2,0
									l21.2,6.2c16.5,4.8,33.6,0.5,45.8-11.7c12.2-12.2,16.5-29.3,11.7-45.8l-6.2-21.2c-3.3-11.2-3.3-23,0-34.2l6.2-21.2
									C209.1,53.6,204.8,36.5,192.6,24.4z"/>
							</g>
							<g id="Combined-Shape" className="st4">
								<path className="st5" d="M108.5-23.1c20.3,0,40.5,10.2,51.7,30.7l10.6,19.4c4.4,8.1,11.1,14.8,19.2,19.2l19.4,10.6
									c40.9,22.4,40.9,81.1,0,103.4L190,170.8c-8.1,4.4-14.8,11.1-19.2,19.2l-10.6,19.4C149,229.8,128.7,240,108.5,240
									c-20.3,0-40.5-10.2-51.7-30.7L46.1,190c-4.4-8.1-11.1-14.7-19.2-19.2L7.6,160.2c-40.9-22.3-40.9-81.1,0-103.4L27,46.1
									c8.1-4.4,14.8-11.1,19.2-19.2L56.7,7.5C67.9-12.9,88.2-23.1,108.5-23.1 M108.5,229.4c16.6,0,33.2-8.4,42.3-25.1l10.6-19.4
									c5.4-9.9,13.5-18,23.4-23.4l19.4-10.6c33.5-18.3,33.5-66.4,0-84.7l-19.4-10.6c-9.9-5.4-18-13.5-23.4-23.4l-10.6-19.4
									c-9.2-16.7-25.7-25.1-42.3-25.1S75.3-4.1,66.1,12.7L55.5,32.1C50.1,42,42,50.1,32.1,55.5L12.7,66.1c-33.5,18.3-33.5,66.4,0,84.7
									l19.4,10.6c9.9,5.4,18,13.5,23.4,23.4l10.6,19.4C75.3,221,91.9,229.4,108.5,229.4 M108.5-27L108.5-27C85.1-27,64.5-14.8,53.3,5.7
									L42.7,25.1c-4.1,7.5-10.2,13.6-17.6,17.6L5.7,53.3C-14.8,64.5-27,85.2-27,108.5c0,23.3,12.2,43.9,32.7,55.1l19.4,10.6
									c7.5,4.1,13.6,10.2,17.6,17.6l10.6,19.4c11.2,20.5,31.8,32.7,55.1,32.7c23.3,0,43.9-12.2,55.1-32.7l10.6-19.4
									c4.1-7.4,10.2-13.5,17.6-17.6l19.4-10.6c20.5-11.2,32.7-31.8,32.7-55.1c0-23.3-12.2-43.9-32.7-55.1l-19.4-10.6
									c-7.4-4.1-13.5-10.2-17.6-17.6L163.6,5.7C152.4-14.8,131.8-27,108.5-27L108.5-27z M108.5,225.5c-16.5,0-31-8.6-38.9-23.1L58.9,183
									c-5.8-10.5-14.4-19.2-25-25l-19.4-10.6c-14.5-7.9-23.1-22.4-23.1-38.9c0-16.5,8.6-31,23.1-38.9l19.4-10.6
									c10.6-5.8,19.2-14.4,25-25l10.6-19.4C77.4,0.1,92-8.5,108.5-8.5c16.5,0,31,8.6,38.9,23.1L158,33.9c5.8,10.6,14.4,19.2,25,25
									l19.4,10.6c14.5,7.9,23.1,22.5,23.1,38.9c0,16.5-8.6,31-23.1,38.9L183,158c-10.6,5.8-19.2,14.4-25,25l-10.6,19.4
									C139.5,216.9,124.9,225.5,108.5,225.5L108.5,225.5z"/>
								<path className="st6" d="M108.5,242c-22.6,0-42.6-11.8-53.4-31.7l-10.6-19.4c-4.2-7.8-10.6-14.1-18.4-18.4L6.6,161.9
									c-19.8-10.8-31.7-30.8-31.7-53.4c0-22.6,11.8-42.6,31.7-53.4L26,44.4c7.8-4.3,14.1-10.6,18.4-18.4L55,6.6
									c10.9-19.8,30.8-31.7,53.4-31.7c22.6,0,42.6,11.8,53.4,31.7L172.5,26c4.3,7.8,10.6,14.2,18.4,18.4L210.3,55
									c19.8,10.9,31.7,30.8,31.7,53.4c0,22.6-11.8,42.6-31.7,53.4l-19.4,10.6c-7.8,4.3-14.2,10.6-18.4,18.4l-10.6,19.4
									C151,230.2,131.1,242,108.5,242z M108.5-10.5c-17.2,0-32.4,9-40.6,24.1L57.2,33c-5.6,10.3-14,18.6-24.2,24.2L13.6,67.8
									c-15.1,8.3-24.1,23.5-24.1,40.7c0,17.2,9,32.4,24.1,40.6L33,159.7c10.2,5.6,18.6,14,24.2,24.2l10.6,19.4
									c8.3,15.1,23.5,24.1,40.6,24.1c17.2,0,32.4-9,40.6-24.1l10.6-19.4c5.6-10.2,14-18.6,24.2-24.2l19.4-10.6
									c15.1-8.2,24.1-23.4,24.1-40.6c0-17.2-9-32.4-24.1-40.7l-19.4-10.6c-10.2-5.6-18.6-14-24.2-24.2l-10.6-19.4
									C140.9-1.5,125.7-10.5,108.5-10.5z"/>
							</g>
						</g>
					</svg>
					<p className="conectando" dangerouslySetInnerHTML={{ __html: initSentenceLoad }}></p>
				</div>
			</div>
		);
	}

};
